import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';

import { initialState, initialSelectedTour } from './initialState';
import { authLoginUserFailure } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import {
  addGroup,
  addHotel,
  createMember,
  createMembers,
  addRoomType,
  createEvent,
  deleteBid,
  deleteEvent,
  deleteGroup,
  fetchAddBidNote,
  fetchAddTour,
  fetchBidsets,
  fetchBrands,
  fetchBrandGroups,
  fetchFindHotels,
  fetchImportRouteStatus,
  fetchPlaces,
  fetchProposal,
  fetchSearchHotels,
  fetchSendBid,
  fetchSendToTour,
  fetchRemoveTourManager,
  fetchTour,
  fetchTours,
  fetchQuestion,
  fetchTourQuestion,
  createQuestion,
  deleteQuestion,
  fetchAddedQuestions,
  addQuestion,
  deleteAddedQuestion,
  fetchAnswers,
  fetchTourDownload,
  patchBid,
  patchBidset,
  patchEvent,
  updateEvent,
  patchGroup,
  postUpdateReOpenBid,
  patchGroupEvent,
  patchMember,
  patchPreferences,
  patchTour,
  postClearRoute,
  postUpdateBids,
  removeMemberFromGroup,
  setFavoriteHotel,
  updateProposal,
  uploadRoster,
  uploadRoute,
  uploadTourImage,
  fetchTourManagers,
  addBidDetails,
  saveAddBookingDetails,
  addGroupData,
  addMultipleBidDetailRecords,
  changeMembersDates,
  getBidDetails,
  getCompareBidsDetails,
  updateBidDates,
  addBulkGroupData,
  addParticipant,
  addHotelFromWeb,
  fetchAddHotelContact,
  fetchSendBidRequests,
  fetchAddBrandContact,
  deleteHotelContact,
  updateHotelContact,
  updateBrandContact,
  deleteBrandContact,
  changePin,
  addNewRoomType,
  fetchRoomType,
  sendCityNotes,
  DeleteNotes
} from '../../../core/api';
import { json } from 'body-parser';
// ------------------------------------
// Constants
// ------------------------------------

export const BID_DELETE_FAILURE = 'BID_DELETE_FAILURE';
export const BID_DELETE_REQUEST = 'BID_DELETE_REQUEST';
export const BID_DELETE_SUCCESS = 'BID_DELETE_SUCCESS';
export const BID_EDIT_FAILURE = 'BID_EDIT_FAILURE';
export const BID_EDIT_REQUEST = 'BID_EDIT_REQUEST';
export const BID_EDIT_SUCCESS = 'BID_EDIT_SUCCESS';
export const BID_SEND_FAILURE = 'BID_SEND_FAILURE';
export const BID_SEND_REQUEST = 'BID_SEND_REQUEST';
export const BID_SEND_SUCCESS = 'BID_SEND_SUCCESS';
export const BID_FILTER_SET = 'BID_FILTER_SET';
export const BID_UPDATE_SEND_REQUEST = 'BID_UPDATE_SEND_REQUEST';
export const BID_UPDATE_SEND_SUCCESS = 'BID_UPDATE_SEND_SUCCESS';
export const BID_UPDATE_SEND_FAILURE = 'BID_UPDATE_SEND_FAILURE';
export const BIDNOTE_EDIT_FETCH_FAILURE = 'BIDNOTE_EDIT_FETCH_FAILURE';
export const BIDNOTE_EDIT_FETCH_REQUEST = 'BIDNOTE_EDIT_FETCH_REQUEST';
export const BIDNOTE_EDIT_FETCH_SUCCESS = 'BIDNOTE_EDIT_FETCH_SUCCESS';
export const BIDSET_LIST_FETCH_FAILURE = 'BIDSET_LIST_FETCH_FAILURE';
export const BIDSET_LIST_FETCH_REQUEST = 'BIDSET_LIST_FETCH_REQUEST';
export const BIDSET_LIST_FETCH_SUCCESS = 'BIDSET_LIST_FETCH_SUCCESS';
export const BRAND_FETCH_FAILURE = 'BRAND_FETCH_FAILURE';
export const BRAND_FETCH_REQUEST = 'BRAND_FETCH_REQUEST';
export const BRAND_FETCH_SUCCESS = 'BRAND_FETCH_SUCCESS';
export const BRAND_GROUP_FETCH_REQUEST = 'BRAND_GROUP_FETCH_REQUEST';
export const BRAND_GROUP_FETCH_SUCCESS = 'BRAND_GROUP_FETCH_SUCCESS';
export const EVENT_ADD_FAILURE = 'EVENT_ADD_FAILURE';
export const EVENT_ADD_REQUEST = 'EVENT_ADD_REQUEST';
export const EVENT_ADD_SUCCESS = 'EVENT_ADD_SUCCESS';
export const EVENT_DELETE_FAILURE = 'EVENT_DELETE_FAILURE';
export const EVENT_DELETE_REQUEST = 'EVENT_DELETE_REQUEST';
export const EVENT_DELETE_SUCCESS = 'EVENT_DELETE_SUCCESS';
export const EVENT_EDIT_FAILURE = 'EVENT_EDIT_FAILURE';
export const EVENT_EDIT_REQUEST = 'EVENT_EDIT_REQUEST';
export const EVENT_EDIT_SUCCESS = 'EVENT_EDIT_SUCCESS';
export const EVENT_STAY_UPDATE_SUCCESS = 'EVENT_STAY_UPDATE_SUCCESS';
export const EVENT_STAY_UPDATE_FAILURE = 'EVENT_STAY_UPDATE_FAILURE';
export const EVENT_SELECT = 'EVENT_SELECT';
export const EVENT_FILTER_SET = 'EVENT_FILTER_SET';
export const GROUP_ADD_REQUEST = 'GROUP_ADD_REQUEST';
export const GROUP_DELETE_FAILURE = 'GROUP_DELETE_FAILURE';
export const GROUP_DELETE_REQUEST = 'GROUP_DELETE_REQUEST';
export const GROUP_DELETE_SUCCESS = 'GROUP_DELETE_SUCCESS';
export const GROUP_EDIT_FAILURE = 'GROUP_EDIT_FAILURE';
export const GROUP_EDIT_REQUEST = 'GROUP_EDIT_REQUEST';
export const GROUP_EDIT_SUCCESS = 'GROUP_EDIT_SUCCESS';
export const GROUPEVENT_EDIT_FAILURE = 'GROUPEVENT_EDIT_FAILURE';
export const GROUPEVENT_EDIT_REQUEST = 'GROUPEVENT_EDIT_REQUEST';
export const GROUPEVENT_EDIT_SUCCESS = 'GROUPEVENT_EDIT_SUCCESS';
export const GROUPMEMBER_REMOVE_FAILURE = 'GROUPMEMBER_REMOVE_FAILURE';
export const GROUPMEMBER_REMOVE_REQUEST = 'GROUPMEMBER_REMOVE_REQUEST';
export const GROUPMEMBER_REMOVE_SUCCESS = 'GROUPMEMBER_REMOVE_SUCCESS';
export const HOTEL_FAVORITE_FETCH_FAILURE = 'HOTEL_FAVORITE_FETCH_FAILURE';
export const HOTEL_FAVORITE_FETCH_REQUEST = 'HOTEL_FAVORITE_FETCH_REQUEST';
export const HOTEL_FAVORITE_FETCH_SUCCESS = 'HOTEL_FAVORITE_FETCH_SUCCESS';
export const HOTEL_FIND_FETCH_FAILURE = 'HOTEL_FIND_FETCH_FAILURE';
export const HOTEL_FIND_FETCH_REQUEST = 'HOTEL_FIND_FETCH_REQUEST';
export const HOTEL_FIND_FETCH_SUCCESS = 'HOTEL_FIND_FETCH_SUCCESS';
export const HOTEL_SELECT_FETCH_FAILURE = 'HOTEL_SELECT_FETCH_FAILURE';
export const HOTEL_SELECT_FETCH_REQUEST = 'HOTEL_SELECT_FETCH_REQUEST';
export const HOTEL_SELECT_FETCH_SUCCESS = 'HOTEL_SELECT_FETCH_SUCCESS';
export const IMPORT_ROSTER_FETCH_FAILURE = 'IMPORT_ROSTER_FETCH_FAILURE';
export const IMPORT_ROSTER_FETCH_REQUEST = 'IMPORT_ROSTER_FETCH_REQUEST';
export const IMPORT_ROSTER_FETCH_SUCCESS = 'IMPORT_ROSTER_FETCH_SUCCESS';
export const IMPORT_ROSTER_FETCH_PENDING = 'IMPORT_ROSTER_FETCH_PENDING';
export const IMPORT_ROUTE_FETCH_FAILURE = 'IMPORT_ROUTE_FETCH_FAILURE';
export const IMPORT_ROUTE_FETCH_REQUEST = 'IMPORT_ROUTE_FETCH_REQUEST';
export const IMPORT_ROUTE_FETCH_SUCCESS = 'IMPORT_ROUTE_FETCH_SUCCESS';
export const IMPORT_ROUTE_FETCH_PENDING = 'IMPORT_ROUTE_FETCH_PENDING';
export const CLEAR_ROUTE_FETCH_FAILURE = 'CLEAR_ROUTE_FETCH_FAILURE';
export const CLEAR_ROUTE_FETCH_REQUEST = 'CLEAR_ROUTE_FETCH_REQUEST';
export const CLEAR_ROUTE_FETCH_SUCCESS = 'CLEAR_ROUTE_FETCH_SUCCESS';
export const BID_CLEAR = 'BID_CLEAR';
export const MEMBER_ADD_FAILURE = 'MEMBER_ADD_FAILURE';
export const MEMBER_ADD_REQUEST = 'MEMBER_ADD_REQUEST';
export const MEMBER_ADD_SUCCESS = 'MEMBER_ADD_SUCCESS';
export const MEMBER_EDIT_FAILURE = 'MEMBER_EDIT_FAILURE';
export const MEMBER_EDIT_REQUEST = 'MEMBER_EDIT_REQUEST';
export const MEMBER_EDIT_SUCCESS = 'MEMBER_EDIT_SUCCESS';
export const MEMBER_EDIT_SUCCESS_MODAL = 'MEMBER_EDIT_SUCCESS_MODAL';
export const PLACE_FETCH_FAILURE = 'PLACE_FETCH_FAILURE';
export const PLACE_FETCH_REQUEST = 'PLACE_FETCH_REQUEST';
export const PLACE_FETCH_SUCCESS = 'PLACE_FETCH_SUCCESS';
export const PROPOSAL_FETCH_FAILURE = 'PROPOSAL_FETCH_FAILURE';
export const PROPOSAL_FETCH_REQUEST = 'PROPOSAL_FETCH_REQUEST';
export const PROPOSAL_FETCH_SUCCESS = 'PROPOSAL_FETCH_SUCCESS';
export const PROPOSAL_SEND_FAILURE = 'PROPOSAL_SEND_FAILURE';
export const PROPOSAL_SEND_REQUEST = 'PROPOSAL_SEND_REQUEST';
export const PROPOSAL_SEND_SUCCESS = 'PROPOSAL_SEND_SUCCESS';
export const SEARCH_HOTEL_CLEAR = 'SEARCH_HOTEL_CLEAR';
export const SEARCH_HOTEL_FETCH_FAILURE = 'SEARCH_HOTEL_FETCH_FAILURE';
export const SEARCH_HOTEL_FETCH_REQUEST = 'SEARCH_HOTEL_FETCH_REQUEST';
export const SEARCH_HOTEL_FETCH_SUCCESS = 'SEARCH_HOTEL_FETCH_SUCCESS';
export const SEARCH_PREFS_FETCH_FAILURE = 'SEARCH_PREFS_FETCH_FAILURE';
export const SEARCH_PREFS_FETCH_REQUEST = 'SEARCH_PREFS_FETCH_REQUEST';
export const SEARCH_PREFS_FETCH_SUCCESS = 'SEARCH_PREFS_FETCH_SUCCESS';
export const TOURMGR_REMOVE_FAILURE = 'TOURMGR_REMOVE_FAILURE';
export const TOURMGR_REMOVE_REQUEST = 'TOURMGR_REMOVE_REQUEST';
export const TOURMGR_REMOVE_SUCCESS = 'TOURMGR_REMOVE_SUCCESS';
export const TOURMGR_SEND_HOTELS_FAILURE = 'TOURMGR_SEND_HOTELS_FAILURE';
export const TOURMGR_SEND_HOTELS_REQUEST = 'TOURMGR_SEND_HOTELS_REQUEST';
export const TOURMGR_SEND_HOTELS_SUCCESS = 'TOURMGR_SEND_HOTELS_SUCCESS';
export const TOURMGR_SEND_TOUR_FAILURE = 'TOURMGR_SEND_TOUR_FAILURE';
export const TOURMGR_SEND_TOUR_REQUEST = 'TOURMGR_SEND_TOUR_REQUEST';
export const TOURMGR_SEND_TOUR_SUCCESS = 'TOURMGR_SEND_TOUR_SUCCESS';
export const TOURMGR_SIM_MODE = 'TOURMGR_SIM_MODE';
export const TOUR_ADD_FAILURE = 'TOUR_ADD_FAILURE';
export const TOUR_ADD_REQUEST = 'TOUR_ADD_REQUEST';
export const TOUR_ADD_SUCCESS = 'TOUR_ADD_SUCCESS';
export const TOUR_EDIT_FAILURE = 'TOUR_EDIT_FAILURE';
export const TOUR_EDIT_REQUEST = 'TOUR_EDIT_REQUEST';
export const TOUR_EDIT_SUCCESS = 'TOUR_EDIT_SUCCESS';
export const TOUR_FETCH_FAILURE = 'TOUR_FETCH_FAILURE';
export const TOUR_FETCH_REQUEST = 'TOUR_FETCH_REQUEST';
export const TOUR_FETCH_SUCCESS = 'TOUR_FETCH_SUCCESS';
export const TOUR_FILTER_SET = 'TOUR_FILTER_SET';
export const TOUR_LIST_FETCH_FAILURE = 'TOUR_LIST_FETCH_FAILURE';
export const TOUR_LIST_FETCH_REQUEST = 'TOUR_LIST_FETCH_REQUEST';
export const TOUR_LIST_FETCH_SUCCESS = 'TOUR_LIST_FETCH_SUCCESS';
export const QUESTIONS_LIST_FETCH_REQUEST = 'QUESTIONS_LIST_FETCH_REQUEST';
export const QUESTIONS_LIST_FETCH_SUCCESS = 'QUESTIONS_LIST_FETCH_SUCCESS';
export const QUESTIONS_LIST_FETCH_FAILURE = 'QUESTIONS_LIST_FETCH_FAILURE';
export const FETCH_ANSWERS_REQUEST = 'FETCH_ANSWERS_REQUEST';
export const FETCH_ANSWERS_SUCCESS = 'FETCH_ANSWERS_SUCCESS';
export const FETCH_ANSWERS_FAILURE = 'FETCH_ANSWERS_FAILURE';
export const FETCH_ADDED_QUESTIONS_REQUEST = 'FETCH_ADDED_QUESTIONS_REQUEST';
export const FETCH_ADDED_QUESTIONS_SUCCESS = 'FETCH_ADDED_QUESTIONS_SUCCESS';
export const FETCH_ADDED_QUESTIONS_FAILURE = 'FETCH_ADDED_QUESTIONS_FAILURE';
export const ADD_QUESTION_REQUEST = 'ADD_QUESTION_REQUEST';
export const ADD_QUESTION_SUCCESS = 'ADD_QUESTION_SUCCESS';
export const QUESTION_ADD_FAILURE = 'QUESTION_ADD_FAILURE';
export const ADD_QUESTION_IN_MAP_REQUEST = 'ADD_QUESTION_IN_MAP_REQUEST';
export const ADD_QUESTION_IN_MAP_SUCCESS = 'ADD_QUESTION_IN_MAP_SUCCESS';
export const QUESTION_ADD_IN_MAP_FAILURE = 'QUESTION_ADD_IN_MAP_FAILURE';
export const DELETE_QUESTION_REQUEST = 'DELETE_QUESTION_REQUEST';
export const DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS';
export const DELETE_QUESTION_FAILURE = 'DELETE_QUESTION_FAILURE';
export const DELETE_MAP_QUESTION_REQUEST = 'DELETE_MAP_QUESTION_REQUEST';
export const DELETE_MAP_QUESTION_SUCCESS = 'DELETE_MAP_QUESTION_SUCCESS';
export const DELETE_MAP_QUESTION_FAILURE = 'DELETE_MAP_QUESTION_FAILURE';
export const TOUR_QUESTIONS_LIST_FETCH_REQUEST = 'TOUR_QUESTIONS_LIST_FETCH_REQUEST';
export const TOUR_QUESTIONS_LIST_FETCH_SUCCESS = 'TOUR_QUESTIONS_LIST_FETCH_SUCCESS';
export const TOUR_QUESTIONS_LIST_FETCH_FAILURE = 'TOUR_QUESTIONS_LIST_FETCH_FAILURE';

export const CHANGE_PIN_TOUR_REQUEST = 'CHANGE_PIN_TOUR_REQUEST';
export const CHANGE_PIN_TOUR_SUCCESS = 'CHANGE_PIN_TOUR_SUCCESS';
export const CHANGE_PIN_TOUR_FAILURE = 'CHANGE_PIN_TOUR_FAILURE';

export const TOUR_SELECT = 'TOUR_SELECT';
export const TOUR_DOWNLOAD_REQUEST = 'TOUR_DOWNLOAD_REQUEST';
export const TOUR_REFRESH_REQUEST = 'TOUR_REFRESH_REQUEST';
export const TOUR_MESSAGE_DISMISS = 'TOUR_MESSAGE_DISMISS';
export const TOUR_MESSAGE_SET = 'TOUR_MESSAGE_SET';
export const TOUR_MANAGER_REQUEST = 'TOUR_MANAGER_REQUEST';
export const TOUR_MANAGER_SUCCESS = 'TOUR_MANAGER_SUCCESS';

export const BIDDETAIL_CHANGE_REQUEST = 'BIDDETAIL_CHANGE_REQUEST';
export const BIDDETAIL_CHANGE_SUCCESS = 'BIDDETAIL_CHANGE_SUCCESS';

export const BIDDETAIL_DELETE__MEMBER_REQUEST = 'BIDDETAIL_DELETE__MEMBER_REQUEST';
export const BIDDETAIL_DELETE__MEMBER_SUCCESS = 'BIDDETAIL_DELETE__MEMBER_SUCCESS';
export const BIDDETAIL_DELETE_MEMBER_FAILURE = 'BIDDETAIL_DELETE_MEMBER_FAILURE';

export const BIDDETE_CHANGE_REQUEST = 'BIDDETE_CHANGE_REQUEST';
export const BIDDETE_CHANGE_SUCCESS = 'BIDDETE_CHANGE_SUCCESS';

export const EDIT_GROUP_EVENT_SUCCESS = 'EDIT_GROUP_EVENT_SUCCESS';
export const EDIT_GROUP_EVENT_FAILURE = 'EDIT_GROUP_EVENT_FAILURE';

export const BIDDETAIL_ADD_REQUEST = 'BIDDETAIL_ADD_REQUEST';
export const BIDDETAIL_ADD_SUCCESS = 'BIDDETAIL_ADD_SUCCESS';
export const ADD_BOOKING_REQUEST = 'ADD_BOOKING_REQUEST';
export const ADD_BOOKING_SUCCESS = 'ADD_BOOKING_SUCCESS';
export const BIDDETAIL_GET_REQUEST = 'BIDDETAIL_GET_REQUEST';
export const BIDDETAIL_GET_SUCCESS = 'BIDDETAIL_GET_SUCCESS';

export const GROUPDATA_ADD_SUCCESS = 'GROUPDATA_ADD_SUCCESS';
export const GROUPDATA_ADD_REQUEST = 'GROUPDATA_ADD_REQUEST';
export const GROUPDATA_ADD_FAILURE = 'GROUPDATA_ADD_FAILURE';

export const MULTIBIDDETAIL_ADD_SUCCESS = 'MULTIBIDDETAIL_ADD_SUCCESS';
export const MULTIBIDDETAIL_ADD_REQUEST = 'MULTIBIDDETAIL_ADD_REQUEST';
export const MULTIBIDDETAIL_ADD_FAILURE = 'MULTIBIDDETAIL_ADD_FAILURE';

export const BULK_MULTIBIDDETAIL_ADD_REQUEST = 'BULK_MULTIBIDDETAIL_ADD_REQUEST';
export const BULK_MULTIBIDDETAIL_ADD_SUCCESS = 'BULK_MULTIBIDDETAIL_ADD_SUCCESS';

export const COMPARE_BID_FETCH_FAILURE = 'COMPARE_BID_FETCH_FAILURE';
export const COMPARE_BID_FETCH_REQUEST = 'COMPARE_BID_FETCH_REQUEST';
export const COMPARE_BID_FETCH_SUCCESS = 'COMPARE_BID_FETCH_SUCCESS';

export const UPDATE_RE_OPEN_BID_REQUEST = 'UPDATE_RE_OPEN_BID_REQUEST';
export const UPDATE_RE_OPEN_BID_SUCCESS = 'UPDATE_RE_OPEN_BID_SUCCESS';
export const UPDATE_RE_OPEN_BID_FAILURE = 'UPDATE_RE_OPEN_BID_FAILURE';

export const ADD_PARTICIPANT_REQUEST = 'ADD_PARTICIPANT_REQUEST';
export const ADD_PARTICIPANT_FAILURE = 'ADD_PARTICIPANT_FAILURE';

export const BULK_GROUPDATA_ADD_REQUEST = 'BULK_GROUPDATA_ADD_REQUEST';
export const BULK_GROUPDATA_ADD_SUCCESS = 'BULK_GROUPDATA_ADD_SUCCESS';
export const BULK_GROUPDATA_ADD_FAILURE = 'BULK_GROUPDATA_ADD_FAILURE';

export const HOTELS_FETCH_REQUEST = 'HOTELS_FETCH_REQUEST';
export const HOTELS_FETCH_SUCCESS = 'HOTELS_FETCH_SUCCESS';

export const HOTEL_SELECT_FROM_WEB_FETCH_REQUEST = 'HOTEL_SELECT_FROM_WEB_FETCH_REQUEST';
export const HOTEL_SELECT_FROM_WEB_FETCH_SUCCESS = 'HOTEL_SELECT_FROM_WEB_FETCH_SUCCESS';

export const ADD_HOTEL_CONTACT_FAILURE = 'ADD_HOTEL_CONTACT_FAILURE';

export const DELETE_HOTEL_CONTACT_SUCCESS = 'DELETE_HOTEL_CONTACT_SUCCESS';
export const DELETE_HOTEL_CONTACT_FAILURE = 'DELETE_HOTEL_CONTACT_FAILURE';

export const UPDATE_HOTEL_CONTACT_SUCCESS = 'UPDATE_HOTEL_CONTACT_SUCCESS';
export const UPDATE_HOTEL_CONTACT_FAILURE = 'UPDATE_HOTEL_CONTACT_FAILURE';

export const ADD_BRAND_CONTACT_SUCCESS = 'ADD_BRAND_CONTACT_SUCCESS';
export const ADD_BRAND_CONTACT_FAILURE = 'ADD_BRAND_CONTACT_FAILURE';

export const REFRESH_PROPOSAL = 'REFRESH_PROPOSAL';
export const ADD_ROOM_TYPE = 'ADD_ROOM_TYPE';

// ------------------------------------
// Actions
// ------------------------------------
export function requestingAddBidNote(bid) {
  return {
    type: BIDNOTE_EDIT_REQUEST,
    payload: bid,
  };
}
export function requestAddBidNoteSuccess(json) {
  return {
    type: BID_EDIT_SUCCESS,
    payload: json,
  };
}
export function requestAddBidNoteFailure(json) {
  return {
    type: BIDNOTE_EDIT_FAILURE,
    payload: json,
  };
}

export function requestingBidEdit(bid) {
  return {
    type: BID_EDIT_REQUEST,
    payload: bid,
  };
}
export function requestBidEditSuccess(json) {
  return {
    type: BID_EDIT_SUCCESS,
    payload: json,
  };
}
export function requestBidEditFailure(json) {
  return {
    type: BID_EDIT_FAILURE,
    payload: json,
  };
}
export function addBrandContactSuccess(json) {
  return {
    type: ADD_BRAND_CONTACT_SUCCESS,
    payload: json,
  };
}
export function addBrandContactFailure(json) {
  return {
    type: ADD_BRAND_CONTACT_FAILURE,
    payload: json,
  };
}
export function selectEvent(id) {
  return {
    type: EVENT_SELECT,
    payload: id,
  };
}
export function bidFilterSet(filter) {
  return {
    type: BID_FILTER_SET,
    payload: filter,
  };
}
export function eventFilterSet(filter) {
  return {
    type: EVENT_FILTER_SET,
    payload: filter,
  };
}
export function messageDismiss(payload) {
  return {
    type: TOUR_MESSAGE_DISMISS,
    payload,
  };
}
export function messageSet(payload) {
  return {
    type: TOUR_MESSAGE_SET,
    payload,
  };
}


export function memberEditSuccessModal(json) {
  return {
    type: MEMBER_EDIT_SUCCESS_MODAL,
    payload: json,
  };
}
export function memberEditSuccess(json) {
  return {
    type: MEMBER_EDIT_SUCCESS,
    payload: json,
  };
}
export function memberEditRequest(json) {
  return {
    type: MEMBER_EDIT_REQUEST,
    payload: json,
  };
}
export function memberEditFailure(json) {
  return {
    type: MEMBER_EDIT_FAILURE,
    payload: json,
  };
}
export function memberAddSuccess(json) {
  return {
    type: MEMBER_ADD_SUCCESS,
    payload: json,
  };
}
export function memberAddRequest(json) {
  return {
    type: MEMBER_ADD_REQUEST,
    payload: json,
  };
}
export function memberAddFailure(json) {
  return {
    type: MEMBER_ADD_FAILURE,
    payload: json,
  };
}
export function editEventSuccess(json) {
  return {
    type: EVENT_EDIT_SUCCESS,
    payload: json,
  };
}

export function editEventFailure(json) {
  return {
    type: EVENT_EDIT_FAILURE,
    payload: json,
  };
}
export function updateEventStaySuccess(json) {
  return {
    type: EVENT_STAY_UPDATE_SUCCESS,
    payload: json,
  };
}
export function updateEventStayFailure(json) {
  return {
    type: EVENT_STAY_UPDATE_FAILURE,
    payload: json,
  };
}
export function editTourSuccess(json) {
  return {
    type: TOUR_EDIT_SUCCESS,
    payload: json,
  };
}
export function editTourFailure(json) {
  return {
    type: TOUR_EDIT_FAILURE,
    payload: json,
  };
}
export function eventAddRequest(json) {
  return {
    type: EVENT_ADD_REQUEST,
    payload: json,
  };
}
export function eventAddSuccess(json) {
  return {
    type: EVENT_ADD_SUCCESS,
    payload: json,
  };
}
export function eventAddFailure(json) {
  return {
    type: EVENT_ADD_FAILURE,
    payload: json,
  };
}
export function eventDeleteRequest(json) {
  return {
    type: EVENT_DELETE_REQUEST,
    payload: json,
  };
}
export function eventDeleteSuccess(json) {
  return {
    type: EVENT_DELETE_SUCCESS,
    payload: json,
  };
}
export function eventDeleteFailure(json) {
  return {
    type: EVENT_DELETE_FAILURE,
    payload: json,
  };
}
export function editGroupEventSuccess(json) {
  return {
    type: GROUPEVENT_EDIT_SUCCESS,
    payload: json,
  };
}
export function editGroupEventFailure(json) {
  return {
    type: GROUPEVENT_EDIT_FAILURE,
    payload: json,
  };
}
export function removeMemberFromGroupRequest() {
  return {
    type: GROUPMEMBER_REMOVE_REQUEST,
    payload: null,
  };
}
export function removeMemberFromGroupSuccess(payload) {
  return {
    type: GROUPMEMBER_REMOVE_SUCCESS,
    payload: payload,
  };
}
export function removeMemberFromGroupFailure(detail) {
  return {
    type: GROUPMEMBER_REMOVE_FAILURE,
    payload: detail,
  };
}

export function requestingAddGroup() {
  return {
    type: GROUP_ADD_REQUEST,
    payload: null,
  };
}
export function requestingAddTour() {
  return {
    type: TOUR_ADD_REQUEST,
    payload: null,
  };
}

export function requestingDeleteBidDetailMember() {
  return {
    type: BIDDETAIL_DELETE__MEMBER_REQUEST,
    payload: null,
  };
}

export function successDeleteBidDetailMember(json) {
  return {
    type: BIDDETAIL_DELETE__MEMBER_SUCCESS,
    payload: json,
  };
}

export function FailureDeleteBidDetailMember(json) {
  return {
    type: BIDDETAIL_DELETE_MEMBER_FAILURE,
    payload: json,
  };
}


export function requestingChangeBidDetail() {
  return {
    type: BIDDETAIL_CHANGE_REQUEST,
    payload: null,
  };
}

export function successChangeBidDetail(json) {
  return {
    type: BIDDETAIL_CHANGE_SUCCESS,
    payload: json,
  };
}

export function failureEditBidEventDetail() {
  return {
    type: EDIT_GROUP_EVENT_FAILURE,
    payload: null,
  };
}

export function successEditBidEventDetail(json) {
  return {
    type: EDIT_GROUP_EVENT_SUCCESS,
    payload: json,
  };
}

export function requestingChangeBidDateDetail() {
  return {
    type: BIDDETE_CHANGE_REQUEST,
    payload: null,
  };
}

export function successChangeBidDateDetail(json) {
  return {
    type: BIDDETE_CHANGE_SUCCESS,
    payload: json,
  };
}

export function requestingAddBidDetail() {
  return {
    type: BIDDETAIL_ADD_REQUEST,
    payload: null,
  };
}

export function successBidAddDetail(json) {
  return {
    type: BIDDETAIL_ADD_SUCCESS,
    payload: json,
  }
}

export function requestingSaveAddBookingData() {
  return {
    type: ADD_BOOKING_REQUEST,
    payload: null,
  };
}

export function successAddBookingRequest(json) {
  return {
    type: ADD_BOOKING_SUCCESS,
    payload: json,
  }
}
export function requestingAddBulkMultiBidDetail() {
  return {
    type: BULK_MULTIBIDDETAIL_ADD_REQUEST,
    payload: null,
  };
}
export function successAddBulkBidAddDetail(json) {
  return {
    type: BULK_MULTIBIDDETAIL_ADD_SUCCESS,
    payload: json,
  };
}
export function requestingAddMultiBidDetail() {
  return {
    type: MULTIBIDDETAIL_ADD_REQUEST,
    payload: null,
  };
}
export function successBidAddMultiDetail(json) {
  return {
    type: MULTIBIDDETAIL_ADD_SUCCESS,
    payload: json,
  };
}
export function requestingaddGroupData() {
  return {
    type: GROUPDATA_ADD_REQUEST,
    payload: null,
  };
}
export function successaddGroupData(json) {
  return {
    type: GROUPDATA_ADD_SUCCESS,
    payload: json,
  }
}
export function addParticipantRequest() {
  return {
    type: ADD_PARTICIPANT_REQUEST,
    payload: null,
  };
}
export function addParticipantFailure() {
  return {
    type: ADD_PARTICIPANT_FAILURE,
    payload: null,
  };
}
export function bulkPostGroupDataRequest() {
  return {
    type: BULK_GROUPDATA_ADD_REQUEST,
    payload: null,
  };
}
export function bulkPostGroupDataSuccess(json) {
  return {
    type: BULK_GROUPDATA_ADD_SUCCESS,
    payload: json,
  }
}
export function bulkPostGroupDataFailure(json) {
  return {
    type: BULK_GROUPDATA_ADD_FAILURE,
    payload: json,
  }
}
export function requestingTour(id) {
  return {
    type: TOUR_FETCH_REQUEST,
    payload: id,
  };
}
export function requestingTours() {
  return {
    type: TOUR_LIST_FETCH_REQUEST,
    payload: null,
  };
}

export function requestingChangePinTour() {
  return {
    type: CHANGE_PIN_TOUR_REQUEST,
    payload: null,
  };
}
export function receiveChangePinTour(json) {
  return {
    type: CHANGE_PIN_TOUR_SUCCESS,
    payload: json,
  };
}

export function requestPinTourError(json) {
  return {
    type: CHANGE_PIN_TOUR_FAILURE,
    payload: json,
  };
}

export function requestingQuestions() {
  return {
    type: QUESTIONS_LIST_FETCH_REQUEST,
    payload: null,
  };
}

export function receiveQuestions(json) {
  return {
    type: QUESTIONS_LIST_FETCH_SUCCESS,
    payload: json.results,
  };
}

export function requestQuestionsError(json) {
  return {
    type: QUESTIONS_LIST_FETCH_FAILURE,
    payload: json,
  }
}

export function requestingTourQuestions() {
  return {
    type: TOUR_QUESTIONS_LIST_FETCH_REQUEST,
    payload: null,
  };
}

export function receiveTourQuestions(json) {
  return {
    type: TOUR_QUESTIONS_LIST_FETCH_SUCCESS,
    payload: json,
  };
}

export function requestTourQuestionsError(json) {
  return {
    type: TOUR_QUESTIONS_LIST_FETCH_FAILURE,
    payload: json,
  }
}

export function questionAddRequest(json) {
  return {
    type: ADD_QUESTION_REQUEST,
    payload: json,
  };
}

export function questionAddSuccess(json) {
  return {
    type: ADD_QUESTION_SUCCESS,
    payload: json,
  }
}

export function questionAddFailure(json) {
  return {
    type: QUESTION_ADD_FAILURE,
    payload: json,
  };
}

export function requestFatchAnswers() {
  return {
    type: FETCH_ANSWERS_REQUEST,
    payload: null,
  };
}

export function receiveFatchAnswers(json) {
  return {
    type: FETCH_ANSWERS_SUCCESS,
    payload: json,
  };
}

export function failureFatchAnswers() {
  return {
    type: FETCH_ANSWERS_FAILURE,
    payload: null,
  };
}

export function requestFatchAddedQuestion() {
  return {
    type: FETCH_ADDED_QUESTIONS_REQUEST,
    payload: null,
  };
}
export function receiveFatchAddedQuestion(json) {
  return {
    type: FETCH_ADDED_QUESTIONS_SUCCESS,
    payload: json,
  };
}
export function failureFatchAddedQuestion() {
  return {
    type: FETCH_ADDED_QUESTIONS_FAILURE,
    payload: null,
  };
}

export function mapquestionAddRequest(json) {
  return {
    type: ADD_QUESTION_IN_MAP_REQUEST,
    payload: json,
  };
}

export function mapquestionAddSuccess(json) {
  return {
    type: ADD_QUESTION_IN_MAP_SUCCESS,
    payload: json,
  }
}

export function mapquestionAddFailure(json) {
  return {
    type: QUESTION_ADD_IN_MAP_FAILURE,
    payload: json,
  };
}

export function questionDeleteRequest(id) {
  return {
    type: DELETE_QUESTION_REQUEST,
    payload: id,
  }
}

export function questionDeleteSuccess(id) {
  return {
    type: DELETE_QUESTION_SUCCESS,
    payload: id,
  }
}

export function questionDeleteFailure(id) {
  return {
    type: DELETE_QUESTION_FAILURE,
    payload: id,
  }
}

export function mapQuestionDeleteRequest(id) {
  return {
    type: DELETE_MAP_QUESTION_REQUEST,
    payload: id,
  }
}

export function mapQuestionDeleteSuccess(id) {
  return {
    type: DELETE_MAP_QUESTION_SUCCESS,
    payload: id,
  }
}

export function mapquestionDeleteFailure(id) {
  return {
    type: DELETE_MAP_QUESTION_FAILURE,
    payload: id,
  }
}

export function requestingTourManagers() {
  return {
    type: TOUR_MANAGER_REQUEST,
    payload: null,
  };
}

export function recevieTourManagers(payload) {
  return {
    type: TOUR_MANAGER_SUCCESS,
    payload,
  };
}

export function refreshingTour(id) {
  return {
    type: TOUR_REFRESH_REQUEST,
    payload: id,
  };
}
export function requestingHotelFind() {
  return {
    type: HOTEL_FIND_FETCH_REQUEST,
    payload: null,
  };
}
export function requestingHotels(id) {
  return {
    type: SEARCH_HOTEL_FETCH_REQUEST,
    payload: id,
  };
}
export function requestingHotelFavorite() {
  return {
    type: HOTEL_FAVORITE_FETCH_REQUEST,
    payload: null,
  };
}
export function receiveBidsets(json) {
  return {
    type: BIDSET_LIST_FETCH_SUCCESS,
    payload: json.results,
  };
}
export function receiveTour(json) {
  return {
    type: TOUR_FETCH_SUCCESS,
    payload: json,
  };
}
export function receiveTours(json) {
  return {
    type: TOUR_LIST_FETCH_SUCCESS,
    payload: json.results,
  };
}
export function receiveFindHotel(json) {
  return {
    type: HOTEL_FIND_FETCH_SUCCESS,
    payload: json,
  };
}
export function receiveProposalSend(json) {
  return {
    type: PROPOSAL_SEND_SUCCESS,
    payload: json,
  };
}
export function receiveBidSend(json) {
  return {
    type: BID_EDIT_SUCCESS,
    payload: json,
  };
}
export function refreshProposal(json) {
  return {
    type: REFRESH_PROPOSAL,
    payload: json,
  };
}
export function requestingBrands() {
  return {
    type: BRAND_FETCH_REQUEST,
    payload: null,
  };
}
export function requestingPlaces() {
  return {
    type: PLACE_FETCH_REQUEST,
    payload: null,
  };
}
export function importingRoute() {
  return {
    type: IMPORT_ROUTE_FETCH_REQUEST,
    payload: null,
  };
}
export function importRoutePending(payload) {
  return {
    type: IMPORT_ROUTE_FETCH_PENDING,
    payload,
  };
}
export function importRouteFailure(payload) {
  return {
    type: IMPORT_ROUTE_FETCH_FAILURE,
    payload,
  };
}
export function clearRouteRequest() {
  return {
    type: CLEAR_ROUTE_FETCH_REQUEST,
  };
}
export function clearRouteSuccess(payload) {
  return {
    type: CLEAR_ROUTE_FETCH_SUCCESS,
    payload,
  };
}
export function clearRouteFailure(payload) {
  return {
    type: CLEAR_ROUTE_FETCH_FAILURE,
    payload,
  };
}
export function importingRoster() {
  return {
    type: IMPORT_ROSTER_FETCH_REQUEST,
    payload: null,
  };
}
export function importRosterFailure(payload) {
  return {
    type: IMPORT_ROSTER_FETCH_FAILURE,
    payload,
  };
}
export function requestingProposals() {
  return {
    type: PROPOSAL_FETCH_REQUEST,
    payload: null,
  };
}
export function requestingBidsets() {
  return {
    type: BIDSET_LIST_FETCH_REQUEST,
    payload: null,
  };
}
export function addingBidNote() {
  return {
    type: BIDNOTE_EDIT_FETCH_REQUEST,
    payload: null,
  };
}
export function requestingHotelSelect() {
  return {
    type: HOTEL_SELECT_FETCH_REQUEST,
    payload: null,
  };
}
export function requestingHotelSelectFromWeb() {
  return {
    type: HOTEL_SELECT_FROM_WEB_FETCH_REQUEST,
    payload: null,
  };
}
export function receiveHotelSelectFromWeb(json) {
  return {
    type: HOTEL_SELECT_FROM_WEB_FETCH_SUCCESS,
    payload: json,
  };
}
export function receiveBrands(json) {
  return {
    type: BRAND_FETCH_SUCCESS,
    payload: json,
  };
}
export function receivePlaces(json) {
  return {
    type: PLACE_FETCH_SUCCESS,
    payload: json,
  };
}
export function receivePreferences(json) {
  return {
    type: SEARCH_PREFS_FETCH_SUCCESS,
    payload: json,
  };
}

export function receiveHotels(json) {
  return {
    type: SEARCH_HOTEL_FETCH_SUCCESS,
    payload: json,
  };
}
export function clearBids() {
  return {
    type: BID_CLEAR,
    payload: null,
  };
}

export function clearHotels() {
  return {
    type: SEARCH_HOTEL_CLEAR,
    payload: null,
  };
}
export function receiveHotelSelect(json) {
  return {
    type: HOTEL_SELECT_FETCH_SUCCESS,
    payload: json,
  };
}
export function receiveHotelFavorite(json) {
  return {
    type: HOTEL_FAVORITE_FETCH_SUCCESS,
    payload: json,
  };
}
export function receiveGroup(json) {
  return {
    type: GROUP_EDIT_SUCCESS,
    payload: json,
  };
}
export function receiveProposals(json) {
  return {
    type: PROPOSAL_FETCH_SUCCESS,
    payload: json.results,
  };
}
export function receiveRouteImport(json) {
  return {
    type: IMPORT_ROUTE_FETCH_SUCCESS,
    payload: json,
  };
}
export function receiveRosterImport(json) {
  return {
    type: IMPORT_ROSTER_FETCH_SUCCESS,
    payload: json,
  };
}
export function requestingGroupDelete(id) {
  return {
    type: GROUP_DELETE_REQUEST,
    payload: id,
  };
}
export function requestGroupDeleteSuccess(id) {
  return {
    type: GROUP_DELETE_SUCCESS,
    payload: id,
  };
}
export function requestGroupDeleteFailure(id) {
  return {
    type: GROUP_DELETE_FAILURE,
    payload: id,
  };
}
export function requestingBidDelete(id) {
  return {
    type: BID_DELETE_REQUEST,
    payload: id,
  };
}
export function requestBidDeleteSuccess(id) {
  return {
    type: BID_DELETE_SUCCESS,
    payload: id,
  };
}
export function requestBidDeleteFailure(id) {
  return {
    type: BID_DELETE_FAILURE,
    payload: id,
  };
}
export function tourDownloadRequest(id) {
  return {
    type: TOUR_DOWNLOAD_REQUEST,
    payload: id,
  };
}
export function sendBidUpdateRequest() {
  return {
    type: BID_UPDATE_SEND_REQUEST,
  };
}
export function sendBidUpdateSuccess(payload) {
  return {
    type: BID_UPDATE_SEND_SUCCESS,
    payload,
  };
}
export function sendBidUpdateFailure(payload) {
  return {
    type: BID_UPDATE_SEND_FAILURE,
    payload,
  };
}
export function updateReOpenBidRequest() {
  return {
    type: UPDATE_RE_OPEN_BID_REQUEST,
  };
}
export function updateReOpenBidSuccess(payload) {
  return {
    type: UPDATE_RE_OPEN_BID_SUCCESS,
    payload,
  };
}
export function updateReOpenBidFailure(payload) {
  return {
    type: UPDATE_RE_OPEN_BID_FAILURE,
    payload,
  };
}
export function removeTourManagerRequest() {
  return {
    type: TOURMGR_REMOVE_REQUEST,
  };
}
export function removeTourManagerSuccess(payload) {
  return {
    type: TOURMGR_REMOVE_SUCCESS,
    payload,
  };
}
export function removeTourManagerFailure(id) {
  return {
    type: TOURMGR_REMOVE_FAILURE,
    payload: id,
  };
}
export function sendToTourManagerRequest() {
  return {
    type: TOURMGR_SEND_TOUR_REQUEST,
  };
}
export function sendToTourManagerSuccess(payload) {
  return {
    type: TOURMGR_SEND_TOUR_SUCCESS,
    payload,
  };
}
export function sendToTourManagerFailure(id) {
  return {
    type: TOURMGR_SEND_TOUR_FAILURE,
    payload: id,
  };
}
export function activateTourManagerSimMode() {
  return {
    type: TOURMGR_SIM_MODE,
    payload: true, // Default filter options,
  };
}
export function clearTourManagerSimMode() {
  return {
    type: TOURMGR_SIM_MODE,
    payload: false,
  };
}

export function getBidDetailsRequest() {
  return {
    type: BIDDETAIL_GET_REQUEST,
    payload: null,
  };
}

export function getBidDetailsSuccess(json, bid) {
  return {
    type: BIDDETAIL_GET_SUCCESS,
    payload: { data: json.results, bid: bid },
  };
}

export function requestFetchHotels() {
  return {
    type: HOTELS_FETCH_REQUEST,
    payload: null,
  };
}

export function successFetchHotels(json) {
  return {
    type: HOTELS_FETCH_SUCCESS,
    payload: json,
  };
}

export function requestingBrandGroups() {
  return {
    type: BRAND_GROUP_FETCH_REQUEST,
    payload: null,
  };
}

export function receiveBrandGroups(json) {
  return {
    type: BRAND_GROUP_FETCH_SUCCESS,
    payload: json,
  };
}

export function addHotelContactFailure(json) {
  return {
    type: ADD_HOTEL_CONTACT_FAILURE,
    payload: json,
  };
}

export function deleteHotelContactFailure() {
  return {
    type: DELETE_HOTEL_CONTACT_FAILURE,
    payload: null,
  };
}

export function successDeleteHotelContact(json) {
  return {
    type: DELETE_HOTEL_CONTACT_SUCCESS,
    payload: json,
  };
}
export function successUpdateHotelContact(json) {
  return {
    type: UPDATE_HOTEL_CONTACT_SUCCESS,
    payload: json,
  };
}
export function updateHotelContactFailure() {
  return {
    type: UPDATE_HOTEL_CONTACT_FAILURE,
    payload: null,
  };
}
export function requestingAddRoomType(json){
  return {
    type:ADD_ROOM_TYPE,
    payload: json,
  };
}

export function setTourManagerSimMode() {
  return (dispatch) => {
    const notificationOpts = {
      // uid: 'once-please', // you can specify your own uid if required
      title: 'Client View',
      message: 'View for clients.',
      autoDismiss: 0,
      action: {
        label: 'Clear',
        callback: () => dispatch(clearTourManagerSimMode()),
      },
    };
    dispatch(Notifications.success(notificationOpts));
    return dispatch(activateTourManagerSimMode());
  };
}
export function tourFilterSet(filter) {
  return {
    type: TOUR_FILTER_SET,
    payload: filter,
  };
}

export function removeBid(id) {
  return (dispatch) => {
    dispatch(requestingBidDelete(id));
    return deleteBid(id)
      .then(checkHttpStatus)
      .then((response) => {
        dispatch(requestBidDeleteSuccess(id, response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(requestBidDeleteFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeBid(id)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeBid(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestBidDeleteFailure(id));
      });
  };
}
export function sendBidUpdate(payload) {
  return (dispatch) => {
    dispatch(sendBidUpdateRequest(payload));
    return postUpdateBids(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(sendBidUpdateSuccess(response));
        // Force reload of bids
        dispatch(clearBids());
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(sendBidUpdateFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(sendBidUpdate(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(sendBidUpdate(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(sendBidUpdateFailure(payload));
      });
  };
}
export function updateReOpenBid(payload, cb) {
  return (dispatch) => {
    dispatch(updateReOpenBidRequest(payload));
    return postUpdateReOpenBid(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(updateReOpenBidSuccess(response));
        cb(response)
        // Force reload of bids
        // dispatch(clearBids());
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(updateReOpenBidFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(updateReOpenBid(payload, cb)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(updateReOpenBid(payload, cb)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(updateReOpenBidFailure(payload));
      });
  };
}
export function editBid(id, payload) {
  return (dispatch) => {
    dispatch(requestingBidEdit(payload));
    return patchBid(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        response['background_color'] = payload.background_color ? payload.background_color : '';
        dispatch(requestBidEditSuccess(response));
        if (['AC', 'PB'].includes(payload.buyer_state)) {
          // Force reload of bids for accept or pre-book
          //dispatch(clearBids());
        }
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              dispatch(requestBidEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editBid(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editBid(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestBidEditFailure(payload));
      });
  };
}
export function addMember(payload) {
  return (dispatch) => {
    dispatch(memberAddRequest(payload));
    createMember(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(refreshTour(response.tour_id));
        if (response.status == "member is created") {
          const notificationOpts = {
            title: 'Member Added',
            message: `${response.first_name} ${response.last_name} added to Group`,
            autoDismiss: 15,
          };
          dispatch(Notifications.success(notificationOpts));
          //dispatch(memberAddSuccess(response));
        } else {
          const notificationOpts = {
            title: 'Yikes!',
            message: 'Sharing via this option is for clients only! The person you are sharing with already has a login with your company. Please do not use this share function for sharing group with co-workers.',
            autoDismiss: 15,
          };
          dispatch(Notifications.error(notificationOpts));
        }
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(memberAddFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Email already exists',
              autoDismiss: 0,
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addMember(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(memberAddFailure(payload));
      });
  };
}


export function editMemberModal(id, payload) {
  return (dispatch) => {
    dispatch(memberEditRequest(payload));
    patchMember(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(memberEditSuccessModal(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(memberEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editMember(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editMember(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(memberEditFailure(payload));
      });
  };
}
export function editMember(id, payload) {
  return (dispatch) => {
    dispatch(memberEditRequest(payload));
    patchMember(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(refreshTour(response.tour_id));
        //dispatch(memberEditSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(memberEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editMember(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editMember(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(memberEditFailure(payload));
      });
  };
}
export function addEvent(payload, cb) {
  return (dispatch) => {
    dispatch(eventAddRequest(payload));
    createEvent(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Event Added',
          message: `${payload.name} added to tour.`,
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(eventAddSuccess(response));
        dispatch(refreshTour(response.tour));
        setTimeout(() => {
          cb(response);
        }, 1000);

      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(eventAddFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addEvent(payload, cb)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addEvent(payload, cb)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(eventAddFailure(payload));
      });
  };
}

export function editEvent(id, payload, cb) {
  return dispatch =>
    // dispatch(requestingBidEdit(payload));
    patchEvent(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(editEventSuccess(response));
        cb(response)
        if (typeof (payload.isCallFromUpdate) != 'undefined' && payload.isCallFromUpdate) {
          dispatch(updateEventStay(id, payload, cb));
        }
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(editEventFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editEvent(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editEvent(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(editEventFailure(payload));
      });
}

export function updateEventStay(id, payload, cb) {
  return dispatch =>
    // dispatch(requestingBidEdit(payload));
    updateEvent(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(updateEventStaySuccess(response));
        dispatch(refreshTour(response.event.tour));
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(updateEventStayFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(updateEventStay(id, payload, cb)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(updateEventStay(id, payload, cb)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(updateEventStayFailure(payload));
      });
}

export function removeEvent(id, payload, cb) {
  return (dispatch) => {
    dispatch(eventDeleteRequest(id));
    return deleteEvent(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Event Removed',
          message: 'Event removed from Tour. Please verify hotel dates.',
          autoDismiss: 5,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(eventDeleteSuccess(id, response));
        dispatch(requestTour(payload.tour_id));
        cb(response);
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(eventDeleteFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeEvent(id, cb)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeEvent(id, cb)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(eventDeleteFailure(id));
      });
  };
}
export function editGroupEvent(id, payload) {
  return dispatch =>
    // dispatch(requestingBidEdit(payload));
    patchGroupEvent(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(editGroupEventSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(editGroupEventFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editGroupEvent(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editGroupEvent(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(editGroupEventFailure(payload));
      });
}
export function addTour(payload) {
  return (dispatch) => {
    dispatch(requestingAddTour());
    return fetchAddTour(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        // Tour added
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Travel Added',
          message: 'Travel plan successfully added.',
          position: 'tr',
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(selectTour(response.id));
        dispatch(push(`/tours/${response.id}/overview`));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          return dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}
export function editTour(id, payload) {
  return dispatch =>
    // dispatch(requestingBidEdit(payload));
    patchTour(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        if (payload.state === 'AC') {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Tour Activated',
            message: 'Sending emails to all members.',
            position: 'tr',
            autoDismiss: 10,
          };
          dispatch(Notifications.success(notificationOpts));
        }
        dispatch(editTourSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(editTourFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editTour(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editEvent(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(editTourFailure(payload));
      });
}
export function editTourImage(id, payload) {
  return dispatch =>
    uploadTourImage(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        if (payload.state === 'AC') {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Tour Activated',
            message: 'Sending emails to all members.',
            position: 'tr',
            autoDismiss: 10,
          };
          dispatch(Notifications.success(notificationOpts));
        }
        dispatch(editTourSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(editTourFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editTour(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editEvent(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(editTourFailure(payload));
      });
}
export function requestToursError(json) {
  return {
    type: TOUR_LIST_FETCH_FAILURE,
    payload: json,
  };
}
export function requestquestions() {
  return (dispatch) => {
    dispatch(requestingQuestions());
    return fetchQuestion()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveQuestions(response));
      })
      .catch((error) => {
        if (error) {
          const status = error.response.status;
          dispatch(Notifications.error(status));
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestQuestionsError());
      })

  }
}
export function requestTourquestions(id, cb) {
  return (dispatch) => {
    dispatch(requestingTourQuestions());
    return fetchTourQuestion(id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveTourQuestions(response));
        cb(response)
      })
      .catch((error) => {
        if (error) {
          const status = error.response.status;
          if (status == undefined || status == null) {
            var statusVal = "data is not avaiable"
            dispatch(Notifications.error(statusVal));
          }
          dispatch(Notifications.error(status));
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestTourQuestionsError());
      })

  }
}
export function createQuestions(payload, cb) {
  return (dispatch) => {
    dispatch(questionAddRequest(payload));
    createQuestion(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        if (response) {
          const notificationOpts = {
            title: 'Question Added',
            message: ` Question added to tour`,
            autoDismiss: 15,
          };
          dispatch(Notifications.success(notificationOpts));
          dispatch(questionAddSuccess(response));
          cb(response)
        } else {
          const notificationOpts = {
            title: 'Yikes!',
            message: 'Question is not added',
            autoDismiss: 15,
          };
          dispatch(Notifications.error(notificationOpts));
        }
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          error.response.json().then((detail) => {
            dispatch(questionAddFailure(detail));
          });
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(createQuestions(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(questionAddFailure(payload));
      });
  };
}

export function AddedQuestions(id, cb) {
  return (dispatch) => {
    dispatch(requestFatchAddedQuestion());
    return fetchAddedQuestions(id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveFatchAddedQuestion(response));
        cb(response)
      })
      .catch((error) => {
        if (error) {
          const status = error.response.status;
          dispatch(Notifications.error(status));
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(failureFatchAddedQuestion());
      })

  }
}

export function createQuestionsmapping(payload) {
  return (dispatch) => {
    dispatch(mapquestionAddRequest(payload));
    addQuestion(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        if (response) {
          const notificationOpts = {
            title: 'Question Added',
            message: ` Question added to tour`,
            autoDismiss: 15,
          };
          dispatch(Notifications.success(notificationOpts));
          dispatch(mapquestionAddSuccess(response));
        } else {
          const notificationOpts = {
            title: 'Yikes!',
            message: 'Question is not added',
            autoDismiss: 15,
          };
          dispatch(Notifications.error(notificationOpts));
        }
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          error.response.json().then((detail) => {
            dispatch(mapquestionAddFailure(detail));
          });
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(createQuestionsmapping(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(mapquestionAddFailure(payload));
      });
  };
}

export function removeQuestion(id, cb) {
  return (dispatch) => {
    dispatch(questionDeleteRequest(id));
    return deleteQuestion(id)
      .then(checkHttpStatus)
      .then((response) => {
        const notificationOpts = {
          title: 'Question Delete',
          message: ` Question deleted to tour`,
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(questionDeleteSuccess(response));
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          error.response.json().then((detail) => {
            dispatch(questionDeleteFailure(detail));
          });
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeQuestion(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(questionDeleteFailure(id));
      });
  };
}
export function removeAddedQuestion(id, payload) {
  return (dispatch) => {
    dispatch(mapQuestionDeleteRequest(id));
    return deleteAddedQuestion(id, payload)
      .then(checkHttpStatus)
      .then((response) => {
        const notificationOpts = {
          title: 'Question Delete',
          message: ` Selected Question deleted to tour`,
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(mapQuestionDeleteSuccess(id, response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          error.response.json().then((detail) => {
            dispatch(mapquestionDeleteFailure(detail));
          });
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeAddedQuestion(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(mapquestionDeleteFailure(id));
      });
  };
}
export function requestAnswers(id, cb) {
  return (dispatch) => {
    dispatch(requestFatchAnswers());
    return fetchAnswers(id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveFatchAnswers(response));
        cb(response)
      })
      .catch((error) => {
        if (error) {
          const status = error.response.status;
          dispatch(Notifications.error(status));
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(failureFatchAnswers());
      })

  }
}
export function requestTours() {
  return (dispatch) => {
    dispatch(requestingTours());
    return fetchTours()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveTours(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestTours()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestToursError());
      });
  };
}

export function changeTourPin(id, payload, cb) {
  return (dispatch) => {
    dispatch(requestingChangePinTour());
    return changePin(payload, id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        cb(response);
        dispatch(receiveChangePinTour(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(changeTourPin(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestPinTourError());
      });
  };
}

export function requestBidDetails(bid, cb) {
  return (dispatch) => {
    dispatch(getBidDetailsRequest());
    return getBidDetails(bid)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(getBidDetailsSuccess(response, bid))
        cb(response);
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestTours()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestToursError());
      });
  };
}

export function requestTourManagers() {
  return (dispatch) => {
    dispatch(requestingTourManagers());
    return fetchTourManagers()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(recevieTourManagers(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestTours()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestToursError());
      });
  };
}


export function addedBidNote(json) {
  return {
    type: BID_EDIT_SUCCESS,
    payload: json,
  };
}

export function postGroupData(payload, cb) {
  return (dispatch) => {
    dispatch(requestingaddGroupData());
    return addGroupData(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        // Tour added
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Travel Added',
          message: 'Travel plan successfully added.',
          position: 'tr',
          autoDismiss: 10,
        };
        //dispatch(Notifications.success(notificationOpts));
        dispatch(successaddGroupData(response));
        cb(response)
        //dispatch(selectTour(response.tour_id));
        //dispatch(push(`/tours/${response.tour_id}/overview`));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          return dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}

export function addParticipantManageBid(payload, cb) {
  return (dispatch) => {
    dispatch(addParticipantRequest());
    return addParticipant(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          title: 'Member Data Added',
          message: 'Member Data Added Successfully.',
          position: 'tr',
          autoDismiss: 2,
        };
        dispatch(Notifications.success(notificationOpts));
        cb(response);
        dispatch(getBidDetailsSuccess(response.BidBidDetails, response.bid));
        dispatch(receiveTour(response.tour));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          return dispatch(addParticipantFailure());
        }
      });
  };
}

export function bulkPostGroupData(payload, cb) {
  return (dispatch) => {
    dispatch(bulkPostGroupDataRequest());
    return addBulkGroupData(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          title: 'Group Data Added',
          message: 'Group Data Added Successfully.',
          position: 'tr',
          autoDismiss: 2,
        };
        dispatch(Notifications.success(notificationOpts));
        for (let i = 0; i < response.group_data.length; i++) {
          let responseData = {
            "group_data": response.group_data[i],
            "id": response.id_list[i],
            "tour_id": response.tour_id
          }
          dispatch(successaddGroupData(responseData));
        }
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          return dispatch(bulkPostGroupDataFailure(payload));
        }
      });
  };
}

export function changeBidDateDetail(payload, isCallFromApplyButton, cb) {
  var isCallFromApplyButton = typeof (isCallFromApplyButton) != 'undefined' ? isCallFromApplyButton : 0;
  return (dispatch) => {
    dispatch(requestingChangeBidDateDetail());
    return addMultipleBidDetailRecords(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        // Tour added
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Group Data Added',
          message: 'Group data successfully added.',
          position: 'tr',
          autoDismiss: 10,
        };
        for (let i = 0; i < response.bid_detail.length; i++) {
          let response_data = {
            "tour_id": response.tour_id,
            "bid_detail": response.bid_detail[i],
            "id": response.id[i]
          }
          dispatch(successChangeBidDateDetail(response_data));
        }
        if (isCallFromApplyButton) {
          dispatch(Notifications.success(notificationOpts));
        }
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // // Most likely connection issues
          // const notificationOpts = {
          //   // uid: 'once-please', // you can specify your own uid if required
          //   title: 'Network Error',
          //   message: 'Ugh. Something is wrong. Try again in a bit.',
          //   autoDismiss: 0,
          // };
          // return dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}

export function editGroupEventOnManageBid(id, payload) {
  return dispatch =>
    // dispatch(requestingBidEdit(payload));
    patchGroupEvent(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(successEditBidEventDetail(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(failureEditBidEventDetail(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editGroupEventOnManageBid(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editGroupEventOnManageBid(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(failureEditBidEventDetail(payload));
      });
}

export function dispatchRemoveMemberFromManageBid(groupId, memberId) {
  return (dispatch) => {
    dispatch(requestingDeleteBidDetailMember());
    return removeMemberFromGroup(groupId, { member: memberId })
      .then(checkHttpStatus)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Member Removed',
          message: 'Tour Member Removed.',
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(successDeleteBidDetailMember({
          id: memberId,
          group: {
            id: groupId
          }
        }));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(FailureDeleteBidDetailMember(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(dispatchRemoveMemberFromManageBid(memberId, groupId)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(dispatchRemoveMemberFromManageBid(memberId, groupId)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestGroupDeleteFailure(memberId));
      });
  };
}

export function addBulkMultipleBidDetail(payload, cb) {
  return (dispatch) => {
    dispatch(requestingAddBulkMultiBidDetail());
    return changeMembersDates(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          title: 'Group Data Added',
          message: 'Group data successfully added.',
          position: 'tr',
          autoDismiss: 10,
        };
        for (let i = 0; i < response.bid_detail.length; i++) {
          let response_data = {
            "tour_id": response.tour_id,
            "bid_detail": response.bid_detail[i],
            "id": response.id[i]
          }
          dispatch(successBidAddDetail(response_data));
        }
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          const notificationOpts = {
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          return dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}
export function changeDateRoomType(payload, cb) {
  return (dispatch) => {
    dispatch(requestingAddBulkMultiBidDetail());
    return changeMembersDates(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          title: 'Group Data Added',
          message: 'Group data successfully added.',
          position: 'tr',
          autoDismiss: 10,
        };
        dispatch(successAddBulkBidAddDetail(response));
        dispatch(refreshTour(response.tour_id));
        cb(response);
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          const notificationOpts = {
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          return dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}
export function ChangeBidDetail(payload, cb) {
  return (dispatch) => {
    dispatch(requestingChangeBidDetail());
    return addBidDetails(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        // Tour added
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Travel Added',
          message: 'Travel plan successfully added.',
          position: 'tr',
          autoDismiss: 10,
        };
        //dispatch(Notifications.success(notificationOpts));
        dispatch(successChangeBidDetail(response));
        cb(response)
        //dispatch(selectTour(response.tour_id));
        //dispatch(push(`/tours/${response.tour_id}/overview`));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          return dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}

export function addBidDetail(payload, cb) {
  return (dispatch) => {
    dispatch(requestingAddBidDetail());
    return addBidDetails(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        // Tour added
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Travel Added',
          message: 'Travel plan successfully added.',
          position: 'tr',
          autoDismiss: 10,
        };
        //dispatch(Notifications.success(notificationOpts));
        dispatch(successBidAddDetail(response));
        cb(response)
        //dispatch(selectTour(response.tour_id));
        //dispatch(push(`/tours/${response.tour_id}/overview`));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          return dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}
export function saveAddBookingData(payload, cb) {
  return (dispatch) => {
    dispatch(requestingSaveAddBookingData());
    return saveAddBookingDetails(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        //Booking added successfuly
        const notificationOpts = {
          title: 'Booking Added',
          message: 'New Booking successfully added.',
          position: 'tr',
          autoDismiss: 10,
        };
        //dispatch(Notifications.success(notificationOpts));
        dispatch(successAddBookingRequest(response));
        cb(response)
        //dispatch(selectTour(response.tour_id));
        //dispatch(push(`/tours/${response.tour_id}/overview`));
      })
      .catch((error) => {
        /*if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          return dispatch(Notifications.error(notificationOpts));
        }*/
      });
  };
}

export function addMultipleBidDetail(payload, isCallFromApplyButton, cb) {
  var isCallFromApplyButton = typeof (isCallFromApplyButton) != 'undefined' ? isCallFromApplyButton : 0;
  return (dispatch) => {
    dispatch(requestingAddMultiBidDetail());
    return addMultipleBidDetailRecords(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        // Tour added
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Group Data Added',
          message: 'Group data successfully added.',
          position: 'tr',
          autoDismiss: 10,
        };
        for (let i = 0; i < response.bid_detail.length; i++) {
          let response_data = {
            "tour_id": response.tour_id,
            "bid_detail": response.bid_detail[i],
            "id": response.id[i]
          }
          dispatch(successBidAddDetail(response_data));
        }
        if (isCallFromApplyButton) {
          dispatch(Notifications.success(notificationOpts));
        }
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // // Most likely connection issues
          // const notificationOpts = {
          //   // uid: 'once-please', // you can specify your own uid if required
          //   title: 'Network Error',
          //   message: 'Ugh. Something is wrong. Try again in a bit.',
          //   autoDismiss: 0,
          // };
          // return dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}
export function addBidNote(id, payload) {
  return (dispatch) => {
    dispatch(addingBidNote());
    return fetchAddBidNote(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(addedBidNote(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!', error);
        }
      });
  };
}
export function requestTourError(id) {
  return {
    type: TOUR_FETCH_FAILURE,
    payload: id,
  };
}

export function requestTour(id) {
  return (dispatch) => {
    dispatch(requestingTour(id));
    return fetchTour(id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveTour(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${id}/overview`));
            });
          }
          // TODO Handle alll the error cases
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          }
          if (status === 404) {
            console.log('Yikes problem with server. ', status);
          }
          if (status > 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestTour(id)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(requestTourError(id));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'Something is wrong. Are you connected to the network?',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestTour(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(requestTourError(id));
        }
        return dispatch(requestTourError(id));
      });
  };
}
export function refreshTour(id) {
  return (dispatch) => {
    dispatch(refreshingTour(id));
    return fetchTour(id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveTour(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${id}/overview`));
            });
          }
          // TODO Handle alll the error cases
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          }
          if (status === 404) {
            console.log('Yikes problem with server. ', status);
          }
          if (status > 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestTour(id)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'Something is wrong. Are you connected to the network?',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestTour(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestTourError(id));
      });
  };
}

export function selectTour(id) {
  return (dispatch) => {
    if (id !== 'undefined') {
      dispatch(requestTour(id));
    } else {
      dispatch(requestingTours());
    }
    return {
      type: TOUR_SELECT,
      payload: id,
    };
  };
}
function handleImportSuccessResponse(response) {
  return (dispatch) => {
    const payload = {};
    payload.tour = response.tour;
    const messages = [];
    messages.push({
      key: 'route-import-0',
      msg: `Route imported. ${response.events} events created.`,
    });
    response.warnings.forEach((warn) => {
      messages.push({
        key: `route-import-${messages.length}`,
        msg: warn,
        style: 'warning',
      });
    });
    payload.messages = messages;
    return dispatch(receiveRouteImport(payload));
  };
}
export function importRouteStatus(tourId) {
  return dispatch => fetchImportRouteStatus(tourId)
    .then(checkHttpStatus)
    .then((response) => {
      // Handle incomplete response
      const status = response.status;
      if (status === 206) {
        setTimeout(() => {
          dispatch(importRouteStatus(tourId));
        }, 10000);
        return dispatch(importRoutePending());
      }
      // const data = parseJSON(response);
      response.json().then(data => dispatch(handleImportSuccessResponse(data)));
    })
    .catch((error) => {
      const payload = {};
      if (error && typeof error.response !== 'undefined') {
        const status = error.response.status;
        if (status >= 401 && status <= 403) {
          // Invalid authentication credentials
          return error.response.json().then((detail) => {
            dispatch(authLoginUserFailure(status, detail));
            dispatch(push(`/login?next=/tours/${tourId}/overview`));
          });
        }
        if (status === 400) {
          error.response.json().then(detail => {
            let statusErrorArray = convertErrorToArray(detail);
            if (statusErrorArray.length > 0) {
              const messages = [];
              statusErrorArray.forEach((err) => {
                messages.push({
                  key: `route-import-${messages.length}`,
                  msg: err,
                  style: 'danger',
                });
              });
              payload.messages = messages;
              dispatch(importRouteFailure(payload));
            } else {
              payload.messages = [{
                msg: detail.status,
                key: 'route-import',
                style: 'danger',
              }];
              dispatch(
                importRouteFailure(payload),
              );
            }
          });
        } else if (status === 504) {
          payload.messages = [{
            msg: 'Importing the route took longer than expected. Please reload the page.',
            key: 'route-import',
            style: 'danger',
          }];
          return dispatch(
            importRouteFailure(payload),
          );
        } else if (status >= 404) {
          payload.messages = [{
            msg: 'Importing the route failed.',
            key: 'route-import',
            style: 'danger',
          }];
          return dispatch(
            importRouteFailure(payload),
          );
        }
      }
      // Most likely connection issues
      payload.messages = [{
        msg: 'Importing the route failed.',
        key: 'route-import',
        style: 'danger',
      }];
      return dispatch(
        importRouteFailure(payload),
      );
    });
}
export function importRoute(tourId, files) {
  return (dispatch) => {
    dispatch(importingRoute());
    return uploadRoute(tourId, files)
      .then(checkHttpStatus)
      .then((response) => {
        // Handle incomplete response
        const status = response.status;
        if (status === 202) {
          dispatch(
            importRoutePending({
              msg: 'Tour is importing. Large tours may take several minutes to process.',
              key: 'route-import',
              style: 'info',
            }),
          );
          return dispatch(importRouteStatus(tourId));
        }
        response.json().then(data => dispatch(handleImportSuccessResponse(data)));
      })
      .catch((error) => {
        const payload = {};
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/overview`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              payload.messages = [{
                msg: detail.status,
                key: 'route-import',
                style: 'danger',
              }];
              dispatch(importRouteFailure(payload));
            });
          } else if (status === 504) {
            payload.messages = [{
              msg: 'Importing the route took longer than expected. Please reload the page.',
              key: 'route-import',
              style: 'danger',
            }];
            return dispatch(importRouteFailure(payload));
          } else if (status >= 404) {
            payload.messages = [{
              msg: 'Importing the route failed.',
              key: 'route-import',
              style: 'danger',
            }];
            return dispatch(importRouteFailure(payload));
          }
        }
        // Most likely connection issues
        payload.messages = [{
          msg: 'Unable to import route.',
          key: 'route-import',
          style: 'danger',
        }];
        return dispatch(importRouteFailure(payload));
      });
  };
}
export function clearRoute(tourId) {
  return (dispatch) => {
    dispatch(clearRouteRequest());
    return postClearRoute(tourId, {})
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const payload = {};
        payload.tour = response.tour;
        const messages = [];
        messages.push({
          key: 'route-import-0',
          msg: 'Route cleared. All events removed.',
        });
        response.warnings.forEach((warn) => {
          messages.push({
            key: `route-import-${messages.length}`,
            msg: warn,
            style: 'warning',
          });
        });
        payload.messages = messages;
        return dispatch(clearRouteSuccess(payload));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/overview`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => dispatch(
              clearRouteFailure({
                msg: detail.status,
                key: 'route-import',
                style: 'danger',
              }),
            ));
          } else if (status >= 404) {
            return dispatch(
              clearRouteFailure({
                msg: 'Error clearing route.',
                key: 'route-import',
                style: 'danger',
              }),
            );
          }
        }
      });
  };
}
export function importRoster(tourId, files) {
  return (dispatch) => {
    dispatch(importingRoster());
    return uploadRoster(tourId, files)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        // TODO: handle import errors or warnings
        const payload = {};
        payload.tour = response.tour;
        const messages = [];
        if (response.warnings.length == 0) {
          messages.push({
            key: 'route-import-0',
            msg: `${response.users} members and ${response.groups} groups created.`,
          });
        } else {
          response.warnings.forEach((warn) => {
            messages.push({
              key: `route-import-${messages.length}`,
              msg: warn,
              style: 'danger',
            });
          });
        }
        payload.messages = messages;
        return dispatch(receiveRosterImport(payload));
        // dispatch(requestTour(tourId));
      })
      .catch((error) => {
        const payload = {};
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/overview`));
            });
          }
          if (status === 400) {
            payload.messages = [];
            const messages = [];
            error.response.json().then(detail => {
              let statusErrorArray = convertErrorToArray(detail);
              if (statusErrorArray.length > 0) {
                let index = 0;
                statusErrorArray.forEach((err) => {
                  payload.messages.push({
                    key: `route-import-${index}`,
                    msg: err,
                    style: 'danger',
                  });
                  index++;
                });
                dispatch(importRouteFailure(payload));
              } else {
                payload.messages = [{
                  msg: detail.status,
                  key: 'route-import',
                  style: 'danger',
                }];
                dispatch(
                  importRouteFailure(payload),
                );
              }
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

export function requestProposals(tourId) {
  return (dispatch) => {
    dispatch(requestingProposals());
    return fetchProposal(tourId)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveProposals(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/3`));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!', error);
          // dispatch()
        }
      });
  };
}

export function requestBidsets(tourId) {
  return (dispatch) => {
    dispatch(requestingBidsets());
    return fetchBidsets(tourId)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        // Iterate all bids list and append random generated 'background_color' to each object based on location group
        const events = [];
        const eventColorData = [];
        let eventColor = '';
        response.results.forEach(bidRecordObj => {
          if (!events.includes(bidRecordObj.bidset.event.id)) {
            events.push(bidRecordObj.bidset.event.id);
            eventColor = getRandomColor();
            eventColorData.push(
              {
                "event": bidRecordObj.bidset.event.id,
                "eventColor": eventColor
              }
            );
          } else {
            for (let i = 0; i < eventColorData.length; i++) {
              if (eventColorData[i].event == bidRecordObj.bidset.event.id) {
                eventColor = eventColorData[i].eventColor;
                break;
              } else {
                eventColor = getRandomColor()
              }
            }
          }

          bidRecordObj['background_color'] = eventColor;
        });

        dispatch(receiveBidsets(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/4`));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

export function favoriteHotel(hotelId, favorite) {
  const payload = { favorite };
  return (dispatch) => {
    dispatch(requestingHotelFavorite());
    return setFavoriteHotel(hotelId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveHotelFavorite(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/2`));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function selectHotel(eventId, payload, cb) {
  return (dispatch) => {
    dispatch(requestingHotelSelect());
    return addHotel(eventId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        cb(response)
        if (response.message) {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Hotel Select',
            message: response.message,
            autoDismiss: 20,
          };
          dispatch(Notifications.info(notificationOpts));
        }
        dispatch(receiveHotelSelect(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/2`));
            });
          }
          if (status === 400) {
            error.response.json().then((message) => {
              const notificationOpts = {
                // uid: 'once-please', // you can specify your own uid if required
                title: 'Hotel Select',
                message: message.message,
                autoDismiss: 20,
              };
              return dispatch(Notifications.error(notificationOpts));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

export function selectHotelFromWeb(eventId, payload, cb) {
  return (dispatch) => {
    dispatch(requestingHotelSelectFromWeb());
    return addHotelFromWeb(eventId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        if (response.message) {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Hotel Select',
            message: response.message,
            autoDismiss: 20,
          };
          dispatch(Notifications.info(notificationOpts));
        }
        dispatch(receiveHotelSelect(response));
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/2`));
            });
          }
          if (status === 400) {
            error.response.json().then((message) => {
              const notificationOpts = {
                // uid: 'once-please', // you can specify your own uid if required
                title: 'Hotel Select',
                message: message.message,
                autoDismiss: 20,
              };
              return dispatch(Notifications.error(notificationOpts));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function searchHotels(eventId) {
  return (dispatch) => {
    dispatch(requestingHotels(eventId));
    return fetchSearchHotels(eventId)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveHotels(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/2`));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

export function findHotels(eventId, name) {
  return (dispatch) => {
    dispatch(requestingHotelFind(name));
    return fetchFindHotels(eventId, name)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveFindHotel(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/2`));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

function formatBrandData(jsonObject) {
  return jsonObject.map(item => ({
    label: item.name,
    value: item.id,
  }));
}
function formatPlaceData(jsonObject) {
  return jsonObject.map(item => ({
    label: `${item.name} (${item.city}, ${item.state})`,
    value: item.id,
  }));
}
export function requestBrandOptions() {
  return (dispatch) => {
    dispatch(requestingBrands());
    return fetchBrands()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveBrands(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=${this.props.location.pathname}`));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function requestBrandGroups() {
  return (dispatch) => {
    dispatch(requestingBrandGroups());
    return fetchBrandGroups()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveBrandGroups(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=${this.props.location.pathname}`));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function requestPlaceOptions() {
  return (dispatch) => {
    dispatch(requestingPlaces());
    return fetchPlaces()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receivePlaces(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=${this.props.location.pathname}`));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function saveBidset(id, payload) {
  return (dispatch) => {
    patchBidset(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveBidset(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=${this.props.location.pathname}`));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}


export function duplicateMemberError() {
  return (dispatch) => {
    const notificationOpts = {
      title: 'Yikes!',
      message: 'Email address already in use',
      autoDismiss: 15,
    };
    dispatch(Notifications.error(notificationOpts));
  };
}
export function dispatchRemoveMemberFromGroup(groupId, memberId) {
  return (dispatch) => {
    dispatch(removeMemberFromGroupRequest());
    return removeMemberFromGroup(groupId, { member: memberId })
      .then(checkHttpStatus)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Member Removed',
          message: 'Tour Member Removed.',
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(removeMemberFromGroupSuccess({
          id: memberId,
          group: {
            id: groupId
          }
        }));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(removeMemberFromGroupFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(dispatchRemoveMemberFromGroup(memberId, groupId)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(dispatchRemoveMemberFromGroup(memberId, groupId)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(removeMemberFromGroupFailure(memberId));
      });
  };
}

export function removeGroup(group) {
  return (dispatch) => {
    dispatch(requestingGroupDelete(group.id));
    return deleteGroup(group.id)
      .then(checkHttpStatus)
      .then((response) => {
        try{
          dispatch(requestGroupDeleteSuccess(group.id, response));
        }
        catch(error){
          console.log('delete successfully!!')
        }
        dispatch(refreshTour(group.tour));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(requestGroupDeleteFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeGroup(group)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeGroup(group.id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestGroupDeleteFailure(group.id));
      });
  };
}

export function newGroup(payload) {
  return (dispatch) => {
    dispatch(requestingAddGroup());
    addGroup(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        fetchTour(response[0].tour)
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
          });
        dispatch(receiveGroup(response));
        dispatch(refreshTour(response[0].tour));
      })
      .catch ((error) => {
    if (error && typeof error.response !== 'undefined') {
      const status = error.response.status;
      if (status === 400) {
        error.response.json().then((detail) => {
          console.log('400: ', detail);
        });
      } else if (status >= 401 && status <= 403) {
        // Invalid authentication credentials
        return error.response.json().then((detail) => {
          dispatch(authLoginUserFailure(status, detail));
          // const redirectAfterLogin = this.props.location.pathname;
          dispatch(push('/login'));
        });
      } else if (status >= 404) {
        console.log('Yikes problem with server. ', status);
      }
    } else {
      // Most likely connection issues
      console.log('An error occurred while sending your data!');
    }
  });
};
}
export function newRoomType(payload){
  return(dispatch)=>{
    dispatch(requestingAddRoomType());
    addNewRoomType(payload)
    .then(checkHttpStatus)
    .then(parseJSON)
    .then((response)=>{
      fetchTour(response[0].tour_id)
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
          });
        dispatch(refreshTour(response[0].tour_id));
    })
    .catch ((error) => {
      if (error && typeof error.response !== 'undefined') {
        const status = error.response.status;
        if (status === 400) {
          error.response.json().then((detail) => {
            console.log('400: ', detail);
          });
        } else if (status >= 401 && status <= 403) {
          // Invalid authentication credentials
          return error.response.json().then((detail) => {
            dispatch(authLoginUserFailure(status, detail));
            // const redirectAfterLogin = this.props.location.pathname;
            dispatch(push('/login'));
          });
        } else if (status >= 404) {
          console.log('Yikes problem with server. ', status);
        }
      } else {
        // Most likely connection issues
        console.log('An error occurred while sending your data!');
      }
    });
  }
}
export function editGroup(id, payload) {
  return (dispatch) => {
    patchGroup(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveGroup(response));
        if (payload.name) {
          // refresh tour in group name changes
          dispatch(refreshTour(response.tour));
        }
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

export function saveRoomPreferences(prefId, payload) {
  return (dispatch) => {
    patchPreferences(prefId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          title: 'Room Preferences',
          message: 'Hotel room preferences are updated.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(clearBids());
        dispatch(receivePreferences(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function saveSearchPreferences(prefId, payload) {
  return (dispatch) => {
    patchPreferences(prefId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          title: 'Search Preferences',
          message: 'Hotel search preferences are updated.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(clearHotels());
        dispatch(receivePreferences(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function saveCityNotes(payload){
  return(dispatch)=>{
    sendCityNotes(payload)
    .then(checkHttpStatus)
    .then(parseJSON)
    .then((response)=>{
      fetchTour(response[0].tour_id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response)=>{
        // dispatch(receiveTour(response));
      })
      // dispatch(refreshTour(response[0].tour_id));
      const notificationOpts = {
        // uid: 'once-please', // you can specify your own uid if required
        title: 'City Notes sent',
        message: 'city notes sent successfully',
        autoDismiss: 20,
      };
      dispatch(Notifications.success(notificationOpts));
    })
    .catch((error) => {
      if (error && typeof error.response !== 'undefined') {
        const status = error.response.status;
        if (status === 400) {
          error.response.json().then((detail) => {
            console.log('400: ', detail);
          });
        } else if (status >= 401 && status <= 403) {
          // Invalid authentication credentials
          return error.response.json().then((detail) => {
            dispatch(authLoginUserFailure(status, detail));
            // const redirectAfterLogin = this.props.location.pathname;
            dispatch(push('/login'));
          });
        } else if (status >= 404) {
          console.log('Yikes problem with server. ', status);
        }
      } else {
        // Most likely connection issues
        console.log('An error occurred while sending your data!');
      }
    });
  }
}

export function DeleteEventNotes(id){
  return (dispatch) =>{
    DeleteNotes(id)
    .then(checkHttpStatus)
    .then(parseJSON)
    .then((response)=>{
      const notificationOpts = {
        // uid: 'once-please', // you can specify your own uid if required
        title: 'City Notes Delete',
        message: 'city notes delete successfully',
        autoDismiss: 20,
      };
      dispatch(Notifications.success(notificationOpts));
    })
    .catch((error) => {
      if (error && typeof error.response !== 'undefined') {
        const status = error.response.status;
        if (status === 400) {
          error.response.json().then((detail) => {
            console.log('400: ', detail);
          });
        } else if (status >= 401 && status <= 403) {
          // Invalid authentication credentials
          return error.response.json().then((detail) => {
            dispatch(authLoginUserFailure(status, detail));
            // const redirectAfterLogin = this.props.location.pathname;
            dispatch(push('/login'));
          });
        } else if (status >= 404) {
          console.log('Yikes problem with server. ', status);
        }
      } else {
        // Most likely connection issues
        console.log('An error occurred while sending your data!');
      }
    });  
  }
}
export function sendProposal(proposalId, payload, from = 'brand', cb) {
  return (dispatch) => {
    updateProposal(proposalId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveProposalSend(response));
        cb(response)
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Requesting Bids',
          message: 'Catch is working to get your hotel pricing.',
          autoDismiss: 20,
        };
        if (from !== 'hotel') {
          dispatch(Notifications.success(notificationOpts));
        }
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function sendBid(bidId, payload) {
  return (dispatch) => {
    fetchSendBid(bidId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Bid Request Sent',
          message: 'Your bid request is on its way.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(receiveBidSend(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function HotelContactUpdate(bidId, payload, cb) {
  return (dispatch) => {
    updateHotelContact(bidId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Add Hotel Contact',
          message: 'Hotel contact update successfully.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(successUpdateHotelContact(response));
        dispatch(receiveBidSend(response));
        cb(response);
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              const notificationOpts = {
                // uid: 'once-please', // you can specify your own uid if required
                title: 'Adding Hotel Contact',
                message: detail.message,
                autoDismiss: 20,
              };
              dispatch(Notifications.error(notificationOpts));
              return dispatch(updateHotelContactFailure());
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Adding Hotel Contact',
              message: 'Error while adding hotel contact. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(updateHotelContactFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Adding Hotel Contact',
            message: 'Error while adding hotel contact. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(updateHotelContactFailure());
        }
      });
  };
}
export function HotelContactDelete(bidId, payload, cb) {
  return (dispatch) => {
    deleteHotelContact(bidId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Add Hotel Contact',
          message: 'Hotel contact deleted successfully.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(successDeleteHotelContact(response));
        dispatch(receiveBidSend(response));
        cb(response);
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              const notificationOpts = {
                // uid: 'once-please', // you can specify your own uid if required
                title: 'Adding Hotel Contact',
                message: detail.message,
                autoDismiss: 20,
              };
              dispatch(Notifications.error(notificationOpts));
              return dispatch(deleteHotelContactFailure());
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Adding Hotel Contact',
              message: 'Error while adding hotel contact. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(deleteHotelContactFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Adding Hotel Contact',
            message: 'Error while adding hotel contact. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(deleteHotelContactFailure());
        }
      });
  };
}
export function HotelBrandContactUpdate(proposalId, payload, cb) {
  return (dispatch) => {
    updateBrandContact(proposalId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Add Hotel Contact',
          message: 'Hotel contact update successfully.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(successUpdateHotelContact(response));
        cb(response);
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              const notificationOpts = {
                // uid: 'once-please', // you can specify your own uid if required
                title: 'Adding Hotel Contact',
                message: detail.message,
                autoDismiss: 20,
              };
              dispatch(Notifications.error(notificationOpts));
              return dispatch(updateHotelContactFailure());
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Adding Hotel Contact',
              message: 'Error while adding hotel contact. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(updateHotelContactFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Adding Hotel Contact',
            message: 'Error while adding hotel contact. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(updateHotelContactFailure());
        }
      });
  };
}
export function HotelBrandContactDelete(proposalId, payload, cb) {
  return (dispatch) => {
    deleteBrandContact(proposalId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Add Hotel Contact',
          message: 'Hotel contact deleted successfully.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(successDeleteHotelContact(response));
        cb(response);
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              const notificationOpts = {
                // uid: 'once-please', // you can specify your own uid if required
                title: 'Adding Hotel Contact',
                message: detail.message,
                autoDismiss: 20,
              };
              dispatch(Notifications.error(notificationOpts));
              return dispatch(deleteHotelContactFailure());
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Adding Hotel Contact',
              message: 'Error while adding hotel contact. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(deleteHotelContactFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Adding Hotel Contact',
            message: 'Error while adding hotel contact. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(deleteHotelContactFailure());
        }
      });
  };
}

export function addHotelContact(bidId, payload, cb) {
  return (dispatch) => {
    fetchAddHotelContact(bidId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Add Hotel Contact',
          message: 'Hotel contact added successfully.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        cb(response);
        dispatch(receiveBidSend(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              const notificationOpts = {
                // uid: 'once-please', // you can specify your own uid if required
                title: 'Adding Hotel Contact',
                message: detail.message,
                autoDismiss: 20,
              };
              dispatch(Notifications.error(notificationOpts));
              return dispatch(addHotelContactFailure());
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Adding Hotel Contact',
              message: 'Error while adding hotel contact. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(addHotelContactFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Adding Hotel Contact',
            message: 'Error while adding hotel contact. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(addHotelContactFailure());
        }
      });
  };
}

export function addBrandContact(proposalId, payload) {
  return (dispatch) => {
    fetchAddBrandContact(proposalId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Add Brand Contact',
          message: 'Brand contact added successfully.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(addBrandContactSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              const notificationOpts = {
                // uid: 'once-please', // you can specify your own uid if required
                title: 'Adding Brand Contact',
                message: detail.message,
                autoDismiss: 20,
              };
              dispatch(Notifications.error(notificationOpts));
              return dispatch(addBrandContactFailure());
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Adding Brand Contact',
              message: 'Error while adding brand contact. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(addBrandContactFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Adding Brand Contact',
            message: 'Error while adding brand contact. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(addBrandContactFailure());
        }
      });
  };
}


export function sendHotelBidRequests(payload, cb) {
  return (dispatch) => {
    fetchSendBidRequests(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Bid Requests Sent',
          message: 'Your bid requests are on their way.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        let bidData = response['bid_data'];
        let proposal = response['proposal'];
        dispatch(refreshProposal(proposal))
        for (let i = 0; i < bidData.length; i++) {
          dispatch(receiveBidSend(bidData[i]));
        }
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}


export function removeTourManager(id, payload) {
  return (dispatch) => {
    dispatch(removeTourManagerRequest());
    fetchRemoveTourManager(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Tour Manager Removed',
          message: 'Removed tour manager access.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        return dispatch(removeTourManagerSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Removing Tour Manager',
              message: 'Error sending the message. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(removeTourManagerFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Removing Tour Manager',
            message: 'Error sending the message. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(removeTourManagerFailure());
        }
      });
  };
}

export function sendToTourManager(id, payload) {
  return (dispatch) => {
    dispatch(sendToTourManagerRequest());
    fetchSendToTour(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Getting ready to collaborate',
          message: 'An invite is on the way.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        return dispatch(sendToTourManagerSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Sending to Tour Manager',
              message: 'Error sending the message. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(sendToTourManagerFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Sending to Tour Manager',
            message: 'Error sending the message. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(sendToTourManagerFailure());
        }
      });
  };
}

const EXTENSIONS = { 'application/pdf': 'pdf', 'application/vnd.ms-excel': 'xlsx' };

function handleTourBlobDownload(blob) {
  const filename = `tour.${EXTENSIONS[blob.type.split(';')[0]]}`;
  if (navigator.appVersion.toString().indexOf('.NET') > 0) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const url = window.URL.createObjectURL(blob);
    const a = document.querySelector('#pdf-link');
    a.href = url;
    a.download = filename;
    a.click();
  }
}
// application/vnd.ms-excel
// application/pdf
export function downloadTourPdf(id, payload) {
  return (dispatch) => {
    dispatch(tourDownloadRequest());
    const notificationOpts = {
      // uid: 'once-please', // you can specify your own uid if required
      title: 'Generating Doc',
      message: 'Exporting travel data.',
      autoDismiss: 20,
    };
    dispatch(Notifications.success(notificationOpts));
    fetchTourDownload(id, payload)
      .then(checkHttpStatus)
      // .then(parseJSON
      .then(response => response.blob())
      .then((blob) => {
        handleTourBlobDownload(blob);
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Error in building document',
              message: 'Unable to generate document',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Travel Doc Generation',
            message: 'Error downloading the file',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}


function getCompareBidsRequest() {
  return {
    type: COMPARE_BID_FETCH_REQUEST,
    payload: null,
  };
}

function getCompareBidsSuccess(json) {
  return {
    type: COMPARE_BID_FETCH_SUCCESS,
    payload: { data: json.results },
  };
}

export function requestCompareBids(tour_id, parent_id) {
  return (dispatch) => {
    dispatch(getCompareBidsRequest());
    return getCompareBidsDetails(tour_id, parent_id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(getCompareBidsSuccess(response))
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestTours()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestToursError());
      });
  };
}

function findById(value) {
  return value.id === Number(this);
}
function findByKey(value) {
  return value.key === this;
}
function findByGUID(value) {
  return value.id === this;
}
function getRandomColor() {
  let letters = 'BCDEF'.split('');
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * letters.length)];
  }
  return color;
}
function convertErrorToArray(response) {
  let errors = [];
  if (response.status !== undefined) {
    let statusError = response.status;
    if (statusError.includes('==')) {
      errors = statusError.split('==');
    } else {
      errors.push(statusError);
    }
  }
  return errors;
}


// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BID_CLEAR]: (state, action) => update(state, {
    selectedTour: {
      bids: { $set: [] },
      proposals: { $set: [] },
      fetches: {
        proposals: { $set: { isFetching: false, needFetch: true } },
        bids: { $set: { isFetching: false, needFetch: true } },
      },
    },
  }),
  [BID_EDIT_REQUEST]: state =>
    update(state, {
      selectedTour: {
        isEditing: {
          $set: true,
        },
      },
    }),
  [BID_DELETE_SUCCESS]: (state, action) => {
    const id = action.payload;
    let proposalId = action.payload.proposal;

    const bidList = state.selectedTour.bids;
    const idx = bidList.findIndex(findById, id);
    let newState = state;
    // Update bids
    if (idx !== -1) {
      proposalId = state.selectedTour.bids[idx].proposal;

      newState = update(state, {
        selectedTour: {
          bids: { $set: [...bidList.slice(0, idx), ...bidList.slice(idx + 1)] },
        },
      });
    }
    const proposalIdx = state.selectedTour.proposals.findIndex(findById, proposalId);
    const bidIdx = state.selectedTour.proposals[proposalIdx].bids.findIndex(findById, id);
    const bids = state.selectedTour.proposals[proposalIdx].bids;
    if (bidIdx !== -1) {
      return update(newState, {
        selectedTour: {
          proposals: {
            [proposalIdx]: {
              bids: {
                $set: [...bids.slice(0, bidIdx), ...bids.slice(bidIdx + 1)],
              },
            },
          },
        },
      });
    }
    return newState;
  },
  [BID_EDIT_SUCCESS]: (state, action) => {
    const id = action.payload.id;
    const proposalId = action.payload.proposal;

    const bidList = state.selectedTour.bids;
    const idx = bidList.findIndex(findById, id);
    let newState;
    // Update bids
    if (idx === -1) {
      newState = update(state, {
        selectedTour: {
          bids: { $push: [action.payload] },
        },
      });
    } else {
      newState = update(state, {
        selectedTour: {
          bids: {
            [idx]: { $set: action.payload },
          },
        },
      });
    }
    const proposalIdx = state.selectedTour.proposals.findIndex(findById, proposalId);
    if (proposalIdx === -1) {
      // Handle when proposals are not loaded
      return newState;
    }
    const bidIdx = state.selectedTour.proposals[proposalIdx].bids.findIndex(findById, id);
    if (bidIdx !== -1) {
      return update(newState, {
        selectedTour: {
          proposals: {
            [proposalIdx]: {
              bids: {
                [bidIdx]: { $set: action.payload },
              },
            },
          },
        },
      });
    }
    return newState;
    // TODO: save and update propsal as well
  },
  [BID_FILTER_SET]: (state, action) => update(state, {
    selectedTour: { bidFilter: { $merge: action.payload } },
  }),
  [BRAND_FETCH_SUCCESS]: (state, action) =>
    update(state, { brands: { $set: formatBrandData(action.payload) } }),
  [BRAND_GROUP_FETCH_SUCCESS]: (state, action) =>
    update(state, { brandgroups: { $set: (action.payload) } }),
  [PLACE_FETCH_SUCCESS]: (state, action) => {
    const places = formatPlaceData(action.payload);
    sessionStorage.setItem('places', JSON.stringify(places));
    return update(state, { places: { $set: places } });
  },
  [EVENT_EDIT_SUCCESS]: (state, action) => {
    const stops = state.selectedTour.tour.tour_stops;
    const event = action.payload;
    for (let i = 0, len = stops.length; i < len; i++) {
      if (stops[i].id === Number(action.payload.id)) {
        return update(state, {
          selectedTour: {
            tour: {
              tour_stops: {
                [i]: { $set: event },
              },
            },
          },
        });
      }
      const idx = stops[i].events.findIndex(findById, action.payload.id);
      if (idx !== -1) {
        return update(state, {
          selectedTour: {
            tour: {
              tour_stops: {
                [i]: {
                  events: { [idx]: { $set: event } },
                },
              },
            },
          },
        });
      }
    }
    return state;
  },
  [EVENT_DELETE_SUCCESS]: (state, action) => {
    const stops = state.selectedTour.tour.tour_stops;
    const event = action.payload;
    for (let i = 0, len = stops.length; i < len; i++) {
      if (stops[i].id === Number(event)) {
        return update(state, {
          selectedTour: {
            tour: {
              tour_stops: { $set: [...stops.slice(0, i), ...stops.slice(i + 1)] },
            },
          },
        });
      }
      const idx = stops[i].events.findIndex(findById, event);
      if (idx !== -1) {
        const events = stops[i].events;
        return update(state, {
          selectedTour: {
            tour: {
              tour_stops: {
                events: { $set: [...events.slice(0, idx), ...events.slice(idx + 1)] },
              },
            },
          },
        });
      }
    }
    return state;
  },
  //[EVENT_ADD_SUCCESS]: 
  [EVENT_FILTER_SET]: (state, action) => update(state, {
    selectedTour: { eventFilter: { $merge: action.payload } },
  }),
  [GROUPDATA_ADD_SUCCESS]: (state, action) => {
    //debugger
    action.payload.group_data.id = action.payload.id
    const idx = state.selectedTour.tour.group_bid_data.findIndex(findById, action.payload.group_data.id);
    const group = action.payload.group_data;
    if (idx !== -1) {
      return update(state, {
        selectedTour: { tour: { group_bid_data: { [idx]: { $set: group } } }, isLoading: { $set: false } },
      });
    }
    return update(state, {
      selectedTour: { tour: { group_bid_data: { $push: [group] } }, isLoading: { $set: false } },
    });

  },
  [BULK_GROUPDATA_ADD_REQUEST]: (state, action) => {
    return update(state, {
      selectedTour: { isLoading: { $set: true } },
    })
  },
  //Bulk group data check uncheck success
  [BULK_GROUPDATA_ADD_SUCCESS]: (state, action) => {
    //debugger
    let tempIdList = action.payload.id_list
    groupData = {}
    for (let i = 0; i < tempIdList.length; i++) {
      action.payload.group_data.id = tempIdList[i]
      const idx = state.selectedTour.tour.group_bid_data.findIndex(findById, action.payload.group_data.id);
      const group = action.payload.group_data[i];
      if (idx !== -1) {
        groupData = update(state, {
          selectedTour: { tour: { group_bid_data: { [idx]: { $set: group } } } },
        });
      }
      groupData = update(state, {
        selectedTour: { tour: { group_bid_data: { $push: [group] } } },
      });
    }
    return update(state, {
      selectedTour: { tour: { group_bid_data: { [idx]: { $set: groupData } } } },
    });
  },
  [GROUP_ADD_REQUEST]: (state, action) => {
    return update(state, {
      selectedTour: { isLoading: { $set: true } },
    })
  },
  [GROUP_EDIT_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.groups.findIndex(findById, action.payload.id);
    const group = action.payload;
    if (idx !== -1) {
      return update(state, {
        selectedTour: { tour: { groups: { [idx]: { $set: group } } }, isLoading: { $set: false } },
      });
    }
    return update(state, {
      selectedTour: { tour: { groups: { $push: [group] } }, isLoading: { $set: false } },
    });
  },
  [GROUP_DELETE_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.groups.findIndex(findById, action.payload);
    const newGroups = state.selectedTour.tour.groups;
    // Update bids
    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          tour: {
            groups: { $set: [...newGroups.slice(0, idx), ...newGroups.slice(idx + 1)] },
          },
        },
      });
    }
    return state;
  },
  [GROUPMEMBER_REMOVE_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.members.findIndex(findById, action.payload.id);
    console.log('members = ', state.selectedTour.tour.members);
    const newMembers = state.selectedTour.tour.members;
    const group = state.selectedTour.tour.groups.find(o => o.id == action.payload.group.id);
    group.members_count--;
    // Update bids
    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          tour: {
            members: { $set: [...newMembers.slice(0, idx), ...newMembers.slice(idx + 1)] },
          },
        },
      });
    }
    return state;
  },
  [GROUPEVENT_EDIT_SUCCESS]: (state, action) => {
    const stops = state.selectedTour.tour.tour_stops;
    const groupEvent = action.payload;
    for (let i = 0, len = stops.length; i < len; i++) {
      const idx = stops[i].related_group_events.findIndex(findById, action.payload.id);
      if (idx !== -1) {
        return update(state, {
          selectedTour: {
            tour: {
              tour_stops: {
                [i]: {
                  related_group_events: { [idx]: { $set: groupEvent } },
                },
              },
            },
          },
        });
      }
    }
    return state;
  },
  [MEMBER_ADD_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.members.findIndex(findById, action.payload.id);
    const groupidx = state.selectedTour.tour.groups.findIndex(findById, action.payload.group.id);
    const group = state.selectedTour.tour.groups.find(o => o.id == action.payload.group.id);
    group.members_count++;
    // state.selectedTour.tour.groups
    // Update bids
    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          tour: {
            members: {
              [idx]: { $set: action.payload },
            },
            groups: {
              [groupidx]: group
            }
          },
        },
      });
    }
    return update(state, {
      selectedTour: {
        tour: {
          members: { $push: [action.payload] },
        },
      },
    });
  },
  [MEMBER_EDIT_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.members.findIndex(findById, action.payload.id);
    //debugger

    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          tour: {
            members: {
              [idx]: { $set: action.payload },
            },
          },
        },
      });
    }


    return update(state, {
      selectedTour: {
        tour: {
          members: { $push: [action.payload] },
        },
      },
    });
  },

  [BULK_MULTIBIDDETAIL_ADD_REQUEST]: (state, action) => {
    return update(state, {
      selectedTour: { isLoading: { $set: true } },
    })
  },

  [MULTIBIDDETAIL_ADD_REQUEST]: (state, action) => {
    return update(state, {
      selectedTour: { isLoading: { $set: true } },
    })
  },

  [MULTIBIDDETAIL_ADD_SUCCESS]: (state, action) => {
    // action.payload.bid_detail.forEach((bid) => {
    //   action.payload.bid_detail.id = action.payload.id;  
    // )}
    const bid_data = action.payload.bid_detail
    for (let i = 0; i < action.payload.bid_detail.length; i++) {
      //bid_data[i].id = action.payload.id[i]  
      let event = { ...state.selectedTour.tour.tour_stops.find(o => o.id == state.selectedTour.selectedEvent) }
      let event_idx = state.selectedTour.tour.tour_stops.findIndex(o => o.id == state.selectedTour.selectedEvent)
      let related_group_events = event.related_group_events.find(o => o.id == action.payload.bid_detail[i].event_id)
      let related_group_events_idx = event.related_group_events.findIndex(o => o.id == action.payload.bid_detail[i].event_id)
      let bid_details_idx = related_group_events.bids.bid_details.findIndex(o => o.id == action.payload.id[i])
      let rge = {}
      if (bid_details_idx !== -1) {
        rge = update(related_group_events, {
          bids: {
            bid_details: {
              [bid_details_idx]: { $set: action.payload.bid_detail[i] },
            },
          }
        });
      } else {
        rge = update(related_group_events, {
          bids: {
            bid_details: { $push: [action.payload.bid_detail[i]] }
          }
        });
      }


      event = update(event, {
        related_group_events: {
          [related_group_events_idx]: { $set: rge }
        }
      })

      return update(state, {
        selectedTour: {
          tour: {
            tour_stops: {
              [event_idx]: { $set: event },
            },
          },
        }
      });

    }
    //action.payload.bid_detail.id = action.payload.id;
  },

  [BIDDETAIL_ADD_SUCCESS]: (state, action) => {
    action.payload.bid_detail.id = action.payload.id;
    let event = { ...state.selectedTour.tour.tour_stops.find(o => o.id == state.selectedTour.selectedEvent) }
    let event_idx = state.selectedTour.tour.tour_stops.findIndex(o => o.id == state.selectedTour.selectedEvent)
    let related_group_events = event.related_group_events.find(o => o.id == action.payload.bid_detail.event_id)
    let related_group_events_idx = event.related_group_events.findIndex(o => o.id == action.payload.bid_detail.event_id)
    let bid_details_idx = related_group_events.bids.bid_details.findIndex(o => o.id == action.payload.id)
    let rge = {}
    if (bid_details_idx !== -1) {
      rge = update(related_group_events, {
        bids: {
          bid_details: {
            [bid_details_idx]: { $set: action.payload.bid_detail },
          },
        }
      });
    } else {
      rge = update(related_group_events, {
        bids: {
          bid_details: { $push: [action.payload.bid_detail] }
        }
      });
    }


    event = update(event, {
      related_group_events: {
        [related_group_events_idx]: { $set: rge }
      }
    })

    return update(state, {
      selectedTour: {
        tour: {
          tour_stops: {
            [event_idx]: { $set: event },
          },
        },
        isLoading: { $set: false },
      }
    });
  },

  [MEMBER_EDIT_SUCCESS_MODAL]: (state, action) => {
    const tourIdx = state.tours.findIndex(findById, state.selectedTour.id);
    const idx = state.selectedTour.tour.members.findIndex(findById, action.payload.id);
    if (idx !== -1) {
      return update(state, {
        tours: {
          [tourIdx]: {
            members: {
              [idx]: { $set: action.payload },
            },
          },
        },
        selectedTour: {
          tour: {
            members: {
              [idx]: { $set: action.payload },
            },
          },
        },
      });
      return update(state, {
        selectedTour: {
          tour: {
            members: {
              [idx]: { $set: action.payload },
            },
          },
        },
      });
    }

    // if (idx !== -1) {
    //   return update(state, {
    //     selectedTour: {
    //       tour: {
    //         members: {
    //           [idx]: { $set: action.payload },
    //         },
    //       },
    //     },
    //   });
    // }

    return update(state, {
      selectedTour: {
        tour: {
          members: { $push: [action.payload] },
        },
      },
    });
  },
  [SEARCH_PREFS_FETCH_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.groups.findIndex(findById, action.payload.group);
    if (idx !== -1) {
      const prefs = action.payload;
      return update(state, {
        selectedTour: {
          tour: {
            groups: {
              [idx]: { hotel_prefs: { $set: prefs } },
            },
          },
        },
      });
    }
    return state;
  },
  [SEARCH_HOTEL_CLEAR]: (state, action) => update(state, {
    hotels: { $set: {} },
    fetchingHotels: { $set: {} },
  }),
  [SEARCH_HOTEL_FETCH_REQUEST]: (state, action) => {
    const eventId = action.payload;
    return update(state, {
      fetchingHotels: {
        [eventId]: { $set: true },
      },
    });
  },
  [SEARCH_HOTEL_FETCH_SUCCESS]: (state, action) => {
    const eventId = action.payload.event;
    const newState = update(state, {
      fetchingHotels: {
        [eventId]: { $set: false },
      },
    });
    return update(newState, {
      hotels: {
        [eventId]: { $set: action.payload.hotels },
      },
    });
  },
  [EVENT_SELECT]: (state, action) => update(state, {
    selectedTour: {
      selectedEvent: { $set: action.payload },
    },
    findHotels: { $set: { hotels: [], fetching: false, search: '' } },
  }),
  [HOTEL_FAVORITE_FETCH_SUCCESS]: (state, action) => {
    const hotelId = action.payload.hotel;
    let newState = state;
    let changed = false;
    for (const eventId in state.hotels) {
      const hotelList = { [eventId]: state.hotels[eventId] };
      const idx = hotelList[eventId].findIndex(findByGUID, hotelId);
      if (idx !== -1) {
        const hotel = { favorite: action.payload.favorite };
        if (changed) {
          newState = update(newState, {
            hotels: {
              [eventId]: { [idx]: { $merge: hotel } },
            },
          });
        } else {
          newState = update(state, {
            hotels: {
              [eventId]: { [idx]: { $merge: hotel } },
            },
          });
        }
        changed = true;
      }
    }
    if (changed) {
      return newState;
    }
    return state;
  },
  [HOTEL_FIND_FETCH_REQUEST]: (state, action) =>
    update(state, {
      findHotels: { $merge: { fetching: true, search: action.payload, hotels: [] } },
    }),
  [HOTEL_FIND_FETCH_SUCCESS]: (state, action) =>
    update(state, {
      findHotels: { $set: { hotels: action.payload, fetching: false } },
    }),
  [HOTEL_SELECT_FETCH_REQUEST]: (state, action) => update(state, {
    selectedTour: {
      fetches: {
        proposals: { $set: { isFetching: false, needFetch: true } },
        bids: { $set: { isFetching: false, needFetch: true } },
      },
    },
  }),
  [HOTEL_SELECT_FETCH_SUCCESS]: (state, action) => {
    const eventId = action.payload.event;
    const hotelList = state.hotels[eventId];
    const hotelId = action.payload.hotels[0].id;
    const findList = state.findHotels.hotels;
    const idx = hotelList.findIndex(findByGUID, hotelId);
    const bidId = action.payload.bid;
    let newData = state
    if (state.selectedTour.bid_id == 0 || true) {
      newData = update(state, {
        selectedTour: {
          bid_id: { $set: bidId }
        }
      })
    }
    if (idx === -1) {
      const newstate = update(newData, {
        hotels: {
          [eventId]: { $push: action.payload.hotels },
        },
      });
      // Check if hotel is find window
      const fidx = findList.findIndex(findByGUID, hotelId);
      if (fidx !== -1) {
        return update(newstate, {
          findHotels: {
            hotels: {
              [fidx]: { $set: action.payload.hotels[0] },
            },
          },
        });
      }
      return newstate;
    }
    return update(newData, {
      hotels: {
        [eventId]: {
          [idx]: { $set: action.payload.hotels[0] },
        },
      },
    });
  },
  [BIDSET_LIST_FETCH_REQUEST]: (state, action) =>
    update(state, {
      selectedTour: { fetches: { bids: { $set: { isFetching: true, needFetch: false } } } },
    }),
  [BIDSET_LIST_FETCH_SUCCESS]: (state, action) =>
    update(state, {
      selectedTour: {
        bids: { $set: action.payload },
        fetches: { bids: { $set: { isFetching: false, needFetch: false } } },
      },
    }),
  [PROPOSAL_FETCH_REQUEST]: (state, action) =>
    update(state, {
      selectedTour: { fetches: { proposals: { $set: { isFetching: true, needFetch: false } } } },
    }),
  [PROPOSAL_FETCH_SUCCESS]: (state, action) =>
    update(state, {
      selectedTour: {
        proposals: { $set: action.payload },
        fetches: { proposals: { $set: { isFetching: false, needFetch: false } } },
      },
    }),
  [PROPOSAL_SEND_SUCCESS]: (state, action) => {
    const proposalId = action.payload.id;
    const proposalList = state.selectedTour.proposals;
    const idx = proposalList.findIndex(findById, proposalId);
    if (idx === -1) {
      return update(state, {
        selectedTour: {
          proposals: { $push: action.payload },
        },
      });
    }
    return update(state, {
      selectedTour: {
        proposals: {
          [idx]: { $set: action.payload },
        },
      },
    });
  },
  [REFRESH_PROPOSAL]: (state, action) => {
    const proposalId = action.payload.id;
    const proposalList = state.selectedTour.proposals;
    const idx = proposalList.findIndex(findById, proposalId);

    return update(state, {
      selectedTour: {
        proposals: {
          [idx]: { $set: action.payload },
        },
      },
    });

  },
  [ADD_BRAND_CONTACT_SUCCESS]: (state, action) => {
    const proposalId = action.payload.id;
    const proposalList = state.selectedTour.proposals;
    const idx = proposalList.findIndex(findById, proposalId);
    if (idx === -1) {
      return update(state, {
        selectedTour: {
          proposals: { $push: action.payload },
        },
      });
    }
    return update(state, {
      selectedTour: {
        proposals: {
          [idx]: { $set: action.payload },
        },
      },
    });
  },
  [CLEAR_ROUTE_FETCH_REQUEST]: (state, action) =>
    update(state, {
      selectedTour: { routeIsProcessing: { $set: true } },
    }),
  [CLEAR_ROUTE_FETCH_SUCCESS]: (state, action) => update(state, {
    selectedTour: {
      messages: { $set: action.payload.messages },
      routeIsProcessing: { $set: false },
      tour: { $set: action.payload.tour },
      proposals: { $set: [] },
      bids: { $set: [] },
      fetches: {
        bids: { $set: { isFetching: false, needFetch: true } },
        proposals: { $set: { isFetching: false, needFetch: true } },
      },
    },
  }),
  [CLEAR_ROUTE_FETCH_FAILURE]: (state, action) => {
    const newState = update(state, {
      selectedTour: { routeIsProcessing: { $set: false } },
    });
    return update(newState, {
      selectedTour: { messages: { $merge: [action.payload] } },
    });
  },
  [IMPORT_ROUTE_FETCH_REQUEST]: (state, action) =>
    update(state, {
      selectedTour: { routeIsProcessing: { $set: true } },
    }),
  [IMPORT_ROUTE_FETCH_PENDING]: (state, action) => {
    if (action.payload) {
      return update(state, {
        selectedTour: { messages: { $merge: [action.payload] } },
      });
    }
    return state;
  },
  [IMPORT_ROUTE_FETCH_SUCCESS]: (state, action) => {
    const newState = update(state, {
      selectedTour: { tour: { $set: action.payload.tour } },
    });
    const newState2 = update(newState, {
      selectedTour: { messages: { $set: action.payload.messages } },
    });
    return update(newState2, {
      selectedTour: { routeIsProcessing: { $set: false } },
    });
  },
  [IMPORT_ROUTE_FETCH_FAILURE]: (state, action) => {
    const newState = update(state, {
      selectedTour: { routeIsProcessing: { $set: false } },
    });
    return update(newState, {
      // selectedTour: { messages: { $merge: [action.payload] } },
      selectedTour: { messages: { $set: action.payload.messages } },
    });
  },
  [IMPORT_ROSTER_FETCH_REQUEST]: (state, action) => update(state, {
    selectedTour: { rosterIsProcessing: { $set: true } },
  }),
  [IMPORT_ROSTER_FETCH_SUCCESS]: (state, action) => {
    const newState = update(state, {
      selectedTour: { tour: { $set: action.payload.tour } },
    });
    const newState2 = update(newState, {
      selectedTour: { messages: { $set: action.payload.messages } },
    });
    return update(newState2, {
      selectedTour: { routeIsProcessing: { $set: false } },
    });
  },
  [IMPORT_ROSTER_FETCH_FAILURE]: (state, action) => {
    const newState = update(state, {
      selectedTour: { rosterIsProcessing: { $set: false } },
    });
    return update(newState, {
      selectedTour: { messages: { $merge: [action.payload] } },
    });
  },
  [TOUR_FILTER_SET]: (state, action) => update(state, {
    tourStateFilter: { $merge: action.payload },
  }),
  [TOUR_SELECT]: (state, action) => {
    const selectedTour = initialSelectedTour;
    selectedTour.id = action.payload;
    selectedTour.isFetching = false;
    selectedTour.needFetch = true;
    return update(state, {
      selectedTour: { $set: selectedTour },
    });
  },
  // eslint-disable-next-line no-unused-vars
  [TOUR_LIST_FETCH_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      isFetching: true,
      hasError: false,
    }),
  [TOUR_LIST_FETCH_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      isFetching: false,
      needFetch: false,
      hasError: false,
      selectedEvent: null,
      tours: action.payload,
    }),
  [QUESTIONS_LIST_FETCH_REQUEST]: (state, action) =>
    update(state, {
      selectedQuestion: { $set: { isFetching: true, questions: [] } },
    }),
  [QUESTIONS_LIST_FETCH_SUCCESS]: (state, action) =>
    update(state, {
      selectedQuestion: {
        $set: { questions: action.payload, isFetching: false }
      },
    }),
  [TOUR_QUESTIONS_LIST_FETCH_REQUEST]: (state, action) =>
    update(state, {
      additionalQuestion: { $set: { isFetching: true, questions: [] } },
    }),
  [TOUR_QUESTIONS_LIST_FETCH_SUCCESS]: (state, action) =>
    update(state, {
      additionalQuestion: {
        $set: { questions: action.payload, isFetching: false }
      },
    }),
  [FETCH_ADDED_QUESTIONS_REQUEST]: (state, action) =>
    update(state, {
      addedQuest: { $set: { isFetching: true, questions: [] } },
    }),
  [FETCH_ADDED_QUESTIONS_SUCCESS]: (state, action) =>
    update(state, {
      addedQuest: {
        $set: { questions: action.payload, isFetching: false }
      },
    }),
  [ADD_QUESTION_SUCCESS]: (state, action) =>
    update(state, {
      addQuestion: {
        $set: { questions: action.payload, isFetching: false }
      },
    }),
  [FETCH_ANSWERS_REQUEST]: (state, action) =>
    update(state, {
      selectedAnswers: { $set: { isFetching: true, answers: [] } },
    }),
  [FETCH_ANSWERS_SUCCESS]: (state, action) =>
    update(state, {
      selectedAnswers: {
        $set: { answers: action.payload, isFetching: false }
      },
    }),
  [CHANGE_PIN_TOUR_SUCCESS]: (state, action) => {
    const idx = state.tours.findIndex(findById, action.payload.tour.id);
    return update(state, {
      tours: { [idx]: { $set: action.payload.tour } },
    });
  },
  // eslint-disable-next-line no-unused-vars
  [TOUR_FETCH_REQUEST]: (state, action) => {
    const selectedTour = Object.assign({}, initialSelectedTour);
    selectedTour.id = action.payload;
    selectedTour.isFetching = true;
    selectedTour.needFetch = false;
    return update(state, {
      selectedTour: { $set: selectedTour },
    });
  },
  [TOUR_FETCH_SUCCESS]: (state, action) => {
    const selectedTour = Object.assign({}, initialSelectedTour);
    if (action.payload.managers && action.payload.managers.length > 0) {
      action.payload.manager = action.payload.managers[0].id.toString();
    }
    selectedTour.id = action.payload.id;
    selectedTour.isFetching = false;
    selectedTour.needFetch = false;
    selectedTour.tour = action.payload;
    const idx = state.tours.findIndex(findById, action.payload.id);
    if (idx === -1) {
      return update(state, {
        selectedTour: { $set: selectedTour },
        tours: { $push: [action.payload] },
      });
    }
    return update(state, {
      selectedTour: { $set: selectedTour },
      tours: { [idx]: { $set: action.payload } },
    });
  },
  [TOUR_FETCH_FAILURE]: (state, action) => update(state, {
    selectedTour: {
      $set: {
        id: action.payload,
        isFetching: false,
        needFetch: false,
        hasError: true,
        tour: {},
      },
    },
  }),
  [TOUR_EDIT_SUCCESS]: (state, action) => {
    const idx = state.tours.findIndex(findById, action.payload.id);
    if (action.payload.managers && action.payload.managers.length > 0) {
      action.payload.manager = action.payload.managers[0].id.toString();
    }
    if (idx === -1) {
      return update(state, {
        tours: { $push: [action.payload] },
        selectedTour: { tour: { $set: action.payload } },
      });
    }
    return update(state, {
      tours: { [idx]: { $set: action.payload } },
      selectedTour: { tour: { $set: action.payload } },
    });
  },
  [TOURMGR_REMOVE_SUCCESS]: (state, action) => {
    const tour = action.payload.tour;
    if (tour) {
      return update(state, {
        selectedTour: {
          tour: { $set: tour },
        },
      });
    }
    return state;
  },
  [TOURMGR_SEND_TOUR_SUCCESS]: (state, action) => {
    const tour = action.payload.tour;
    if (tour) {
      return update(state, {
        selectedTour: {
          tour: { $set: tour },
        },
      });
    }
    return state;
  },
  [TOURMGR_SIM_MODE]: (state, action) => update(state, {
    tourManagerSim: { $set: action.payload },
  }),
  [TOUR_MESSAGE_SET]: (state, action) => {
    const idx = state.selectedTour.messages.findIndex(findByKey, action.payload.key);
    const messages = state.selectedTour.messages;
    // Update bids
    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          messages: { $set: [action.payload] },
        },
      });
    }
    return update(state, {
      selectedTour: {
        messages: { $set: [action.payload] },
      },
    });
  },
  [TOUR_MESSAGE_DISMISS]: (state, action) => {
    const idx = state.selectedTour.messages.findIndex(findByKey, action.payload.key);
    const messages = state.selectedTour.messages;
    // Update bids
    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          messages: { $set: [...messages.slice(0, idx), ...messages.slice(idx + 1)] },
        },
      });
    }
    return state;
  },

  [TOUR_MANAGER_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      tourManagers: [],
    }),
  [TOUR_MANAGER_SUCCESS]: (state, action) =>

    // const data = [];
    // for (let index = 0; index < action.payload.agents.length; index++) {
    //   const element = action.payload.agents[index];
    //   data.push({
    //     value :element.element,
    //     label : element.username
    //   })
    // }

    Object.assign({}, state, {
      tourManagers: action.payload.agents,
    }),
  [BIDDETAIL_GET_SUCCESS]: (state, action) => {
    // bidbidsDetails
    return Object.assign({}, state, {
      bidbidsDetails: action.payload.data,
    })

  },
  [COMPARE_BID_FETCH_REQUEST]: (state, action) => update(state, {
    compareBids: { $set: [] }
  }),
  [COMPARE_BID_FETCH_SUCCESS]: (state, action) => update(state, {
    compareBids: { $set: action.payload.data }
  })
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function toursReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}


// WEBPACK FOOTER //
// src/routes/tours/modules/tour.js